import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Formik, Field } from 'formik'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { GetEditOutlet, GetOutletDetail, CreateOutlet, GetZatcaConfigurationsList, AddZatcaRegistration, registerToZatcaAgain } from '../../services/company_panel/outletService'
import { GetBrandList } from '../../services/company_panel/brandService'
import Swal from "sweetalert2"
import Breadcrums from '../../components/company_panel/common/breadcrumbs'
import $ from "jquery"
import { capitalizeAllFirstLetters, capitalizeFirstLetter, formateDate, getBrandId, getCompany, getOutletId } from '../../helpers/commonFunctions';
import TableLoader from '../../components/company_panel/common/loader'
import notFound from '../../assets/company/img/no-record-found.png'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAllAreas, DetailsArea } from '../../services/company_panel/setting/settingAreaServices';
import Select from 'react-select';
import { Form, InputGroup, Modal, Button } from 'react-bootstrap';
import { getAllMenus } from '../../services/company_panel/categoryService'
import { ListGroups } from '../../services/company_panel/routingStationService'
import { Dropdown } from 'semantic-ui-react'
import {
    CitySelect,
    StateSelect,
    CountrySelect,
    GetState,
    GetCity,
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import "./locationSelect.css";
// import ZatcaSampleFileXlsx from '../../assets/company/outletZatcaSampleFiles/ZatcaCertificateSample.xlsx';
// import ZatcaSampleFileXls from '../../assets/company/outletZatcaSampleFiles/ZatcaCertificateSample.xls';
// import ZatcaSampleFileCsv from '../../assets/company/outletZatcaSampleFiles/ZatcaCertificateSample.csv';
// import ZatcaSampleFileJSON from '../../assets/company/outletZatcaSampleFiles/ZatcaCertificateSample.json';

import { LOADER_TIME, zatcaEnvironmentType } from '../../utils/Constants'
import { Loader, Tooltip, Whisper } from 'rsuite'

const ZatcaSampleFileJsonPath = '/assets/company/zatcaSampleCertificates/ZatcaCertificateSample.json';

// Empty selection for the country/state/city dropdowns, which only clear their
// displayed text when they get an object with a blank name.
const EMPTY_LOCATION = { id: '', name: '' };

const areaSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: 42,
        borderRadius: 4,
        fontSize: 14,
        backgroundColor: '#fff',
        borderColor: state.isFocused ? '#2f9bff' : '#e8e8e8',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(47, 155, 255, 0.15)' : 'none',
        '&:hover': { borderColor: '#2f9bff' },
    }),
    valueContainer: (base) => ({ ...base, padding: '2px 12px' }),
    placeholder: (base) => ({ ...base, color: '#9aa0a6', fontSize: 14 }),
    singleValue: (base) => ({ ...base, color: '#2c1d37' }),
    input: (base) => ({ ...base, color: '#2c1d37', margin: 0, padding: 0 }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base, state) => ({
        ...base,
        color: state.isFocused ? '#2f9bff' : '#9aa0a6',
        padding: 6,
        transition: 'transform .2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
        '&:hover': { color: '#2f9bff' },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({
        ...base,
        marginTop: 4,
        borderRadius: 8,
        border: '1px solid #ececec',
        boxShadow: '0 8px 24px rgba(44, 29, 55, 0.12)',
        overflow: 'hidden',
    }),
    menuList: (base) => ({
        ...base,
        padding: 6,
        '::-webkit-scrollbar': { width: 6 },
        '::-webkit-scrollbar-thumb': { background: '#d9d9d9', borderRadius: 6 },
    }),
    option: (base, state) => ({
        ...base,
        padding: '9px 12px',
        borderRadius: 6,
        fontSize: 14,
        cursor: 'pointer',
        color: state.isSelected ? '#fff' : '#2c1d37',
        backgroundColor: state.isSelected
            ? '#2f9bff'
            : state.isFocused
                ? 'rgba(47, 155, 255, 0.10)'
                : 'transparent',
        '&:active': { backgroundColor: state.isSelected ? '#2f9bff' : 'rgba(47, 155, 255, 0.18)' },
    }),
    noOptionsMessage: (base) => ({ ...base, fontSize: 14, color: '#9aa0a6' }),
    loadingMessage: (base) => ({ ...base, fontSize: 14, color: '#9aa0a6' }),
};

const OutletEdit = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { outletName } = location.state || {};
    const params = useParams();
    const editFormRef = useRef();
    const [searchParams] = useSearchParams();
    const [showDefault, setShowDefault] = useState({})
    const [submitted, setSubmitted] = useState(false)
    const [brandList, setBrandList] = useState([])
    const [addMoreCount, setAddMoreCount] = useState([]);
    const storeTime = [
        { value: 'monday', label: 'Monday' },
        { value: 'tuesday', label: 'Tuesday' },
        { value: 'wednesday', label: 'Wednesday' },
        { value: 'thursday', label: 'Thursday' },
        { value: 'friday', label: 'Friday' },
        { value: 'saturday', label: 'Saturday' },
        { value: 'sunday', label: 'Sunday' },
    ];
    const [selectedOption, setSelectedOption] = useState('');
    const [btnDisable, setBtnDisable] = useState(false);
    const [page, setPage] = useState(1);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [areas, setAreas] = useState([]);
    const [areaPage, setAreaPage] = useState(1);
    const [areaHasMore, setAreaHasMore] = useState(false);
    const [areaLoading, setAreaLoading] = useState(false);
    const [areaBrandId, setAreaBrandId] = useState(null);
    const [selectedArea, setSelectedArea] = useState(null);
    const AREA_PER_PAGE = 10;
    const [menus, setMenus] = useState([]);
    const [routingGroup, setRoutingGroup] = useState([])
    const [isBrandChanged, setIsBrandChanged] = useState(false);

    const [countryid, setCountryid] = useState(0);
    const [stateid, setstateid] = useState(0);
    const [cityid, setcityid] = useState(0);
    const [cityName, setCityName] = useState('');


    const handleOptionChange = (event) => {
        setSelectedOption(event);
    };

    const breadcrumbs = [
        {
            title: "Outlet",
            url: `/company/business/outlet/list/${params.pgno || 1}`
        },
        {
            title: searchParams.get("copy") ? "Create Outlet" : "Edit Outlet",
            url: ""
        },
    ]

    const [selectedTime, setSelectedTime] = useState({

    });

    const [hardwareDetail, setHardwareDetail] = useState({
        1: {
            hardware_used: 'printer',
            // printer_type: null, //to be remove
            routing_groups: null,
            registration_id: null,
            // printer_ip: null, //to be remove
            name: null,
            // sdk_id: null,
            select_menu: null,
            swipe_machine : null,
        }
    });
    const [hardwareError, setHardwareError] = useState({});
    const [swipeMachineIndex, setSwipeMachineIndex] = useState(-1);

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
    });

    useEffect(() => {

        GetOutletDetail(params.id).then(data => {

            const dataOutlet = data && data.data && data.data.response ? data.data.response : [];
            setShowDefault(dataOutlet)
            setCountryid(data.data.response.country_id)
            setstateid(data.data.response.state_id)
            setcityid(data.data.response.city_id)
            setCityName(data.data.response?.city_id?.name);
            // if (data.data.response.country_id && data.data.response.state_id && data.data.response.city_id) {
            //     GetCity(data.data.response.country_id, data.data.response.state_id).then(cities => {
            //         const city = cities.find(c => Number(c.id) === Number(data.data.response.city_id));
            //         if (city) setCityName(city.name);
            //     }).catch(() => {});
            // }
            setSelectedOption(dataOutlet?.end_of_the_day_configuration);
            setAreaBrandId(dataOutlet?.brand_id)
            fetchAreas(dataOutlet?.brand_id, 1, false)

            // The area list is paginated, so the saved area may not be on the first page.
            // Fetch it separately to keep the selected label visible.
            if (dataOutlet?.area_id) {
                DetailsArea({ id: dataOutlet.area_id }).then(areaData => {
                    setSelectedArea(areaData?.data?.response || null)
                }).catch(error => {
                    console.log("error=====>", error)
                })
            }

            getAllMenus({ brand_id: dataOutlet?.brand_id }).then(data => {
                setMenus(data && data.data && data.data.response ? data.data.response : [])
            }).catch(error => {
                console.log("error=====>", error)
            })

            ListGroups({ brand_id: dataOutlet?.brand_id }).then(data => {
                setRoutingGroupList(data?.data?.response?.rows || []);
            }).catch(error => {
                console.log("error ====> ", error);
            })
            const timeCheckbox = [
                { value: 'monday', label: 'Monday', opening_time: dataOutlet.monday_opening_time, closing_time: dataOutlet.monday_closing_time, is_day: dataOutlet.is_monday },
                { value: 'tuesday', label: 'Tuesday', opening_time: dataOutlet.tuesday_opening_time, closing_time: dataOutlet.tuesday_closing_time, is_day: dataOutlet.is_tuesday },
                { value: 'wednesday', label: 'Wednesday', opening_time: dataOutlet.wednesday_opening_time, closing_time: dataOutlet.wednesday_closing_time, is_day: dataOutlet.is_wednesday },
                { value: 'thursday', label: 'Thursday', opening_time: dataOutlet.thursday_opening_time, closing_time: dataOutlet.thursday_closing_time, is_day: dataOutlet.is_thursday },
                { value: 'friday', label: 'Friday', opening_time: dataOutlet.friday_opening_time, closing_time: dataOutlet.friday_closing_time, is_day: dataOutlet.is_friday },
                { value: 'saturday', label: 'Saturday', opening_time: dataOutlet.saturday_opening_time, closing_time: dataOutlet.saturday_closing_time, is_day: dataOutlet.is_saturday },
                { value: 'sunday', label: 'Sunday', opening_time: dataOutlet.sunday_opening_time, closing_time: dataOutlet.sunday_closing_time, is_day: dataOutlet.is_sunday },
            ];
            setTimeout(() => {
                storeTime.forEach(item => {
                    editFormRef?.current?.setFieldValue(`is_${item.value}`, dataOutlet[`is_${item.value}`]);
                });
            }, 1000);

            const hardware = data && data.data && data.data.response ? data.data.response.outlet_hardware_details : [];
            setAddMoreCount([]);
            setHardwareDetail({});

            hardware.forEach(function (row, index) {
                setAddMoreCount(prevValues => [...prevValues, 1]);
                const routingGroupsArray = row?.outlet_routing_group_relations?.map(item => item?.routing_) || [];
                var hardwareData = {
                    id: row.id,
                    hardware_used: row.hardware_used,
                    // printer_type: row.printer_type, //to be remove
                    // printer_ip: row.printer_ip, //to be remove
                    routing_groups: routingGroupsArray,
                    registration_id: row.registration_id,
                    name: row.name,
                    // sdk_id: row.sdk_id, //to be remove
                    select_menu: row.select_menu,
                    swipe_machine : row.swipe_machine,
                    customer_printer_name : row.customer_printer_name,
                    customer_printer_ip : row.customer_printer_ip,
                    kitchen_printer_name : row.kitchen_printer_name,
                    kitchen_printer_ip : row.kitchen_printer_ip,
                    kitchen_device_name : row.kitchen_device_name,
                    kitchen_device_registration_id : row.kitchen_device_registration_id,
                    is_main_cashier: row.is_main_cashier,
                    zatca_configuration_id: row.zatca_configuration_id || null
                };

                if(hardwareData.hardware_used == 'swipe_machine'){
                    setSwipeMachineIndex(index + 1);
                }
                const newId = index + 1;
                updateHardwareDetail(newId, hardwareData);
            });

            if (dataOutlet) {

                setSelectedTime({
                    sunday_opening_time: dataOutlet.sunday_opening_time,
                    monday_opening_time: dataOutlet.monday_opening_time,
                    tuesday_opening_time: dataOutlet.tuesday_opening_time,
                    wednesday_opening_time: dataOutlet.wednesday_opening_time,
                    thursday_opening_time: dataOutlet.thursday_opening_time,
                    friday_opening_time: dataOutlet.friday_opening_time,
                    saturday_opening_time: dataOutlet.saturday_opening_time,
                    sunday_closing_time: dataOutlet.sunday_closing_time,
                    monday_closing_time: dataOutlet.monday_closing_time,
                    tuesday_closing_time: dataOutlet.tuesday_closing_time,
                    wednesday_closing_time: dataOutlet.wednesday_closing_time,
                    thursday_closing_time: dataOutlet.thursday_closing_time,
                    friday_closing_time: dataOutlet.friday_closing_time,
                    saturday_closing_time: dataOutlet.saturday_closing_time,
                });
            }
        }).catch(error => {
            console.log("error=====>", error)
        })


        GetBrandList(getCompany().company_id).then(data => {
            setBrandList(data && data?.data && data?.data?.response ? data?.data?.response : [])
        }).catch(error => {
            console.log("error=====>", error)
        })

        GetZatcaConfigurationsList({ outlet_id: params.id }).then(data => {
            setDeviceZatcaList(data?.data?.response || []);
        }).catch(err => console.log(err));

    }, [isBrandChanged])

    console.log(cityName, '======cityname');

    const fetchAreas = (brand_id, page, append) => {
        if (!brand_id || areaLoading) {
            return
        }
        setAreaLoading(true)
        getAllAreas({ brand_id: brand_id, page, per_page: AREA_PER_PAGE }).then(data => {
            const response = data?.data?.response || {}
            const rows = response.rows || []
            const count = response.count || 0
            setAreas(prev => append ? [...prev, ...rows] : rows)
            setAreaPage(page)
            setAreaHasMore(page * AREA_PER_PAGE < count)
        }).catch(error => {
            console.log("error=====>", error)
        }).finally(() => {
            setAreaLoading(false)
        })
    }

    const getArea = (brand_id) => {
        setAreaBrandId(brand_id)
        setSelectedArea(null)
        if (!brand_id) {
            setAreas([])
            setAreaHasMore(false)
            return
        }
        fetchAreas(brand_id, 1, false)
    }

    const loadMoreAreas = () => {
        if (areaHasMore && !areaLoading) {
            fetchAreas(areaBrandId, areaPage + 1, true)
        }
    }

    // Search only filters what is already loaded, so pull the next page when the
    // typed text has no match yet.
    const searchAreas = (input, { action }) => {
        if (action !== 'input-change' || !input) {
            return
        }
        const hasMatch = areaOptions.some(option => option.label?.toLowerCase().includes(input.toLowerCase()))
        if (!hasMatch) {
            loadMoreAreas()
        }
    }

    const areaOptions = [
        ...(selectedArea && !(areas || []).some(area => area.id === selectedArea.id)
            ? [{ value: selectedArea.id, label: selectedArea.name }]
            : []),
        ...(areas || []).map((area) => ({ value: area.id, label: area.name })),
    ]

    const selectFirstCity = (country_id, state_id, setFieldValue) => {
        if (!country_id || !state_id) {
            return
        }
        return GetCity(country_id, state_id).then(cities => {
            const firstCity = cities && cities.length ? cities[0] : null
            if (!firstCity) {
                return
            }
            setcityid(firstCity)
            setFieldValue('city_id', firstCity)
            setCityName(firstCity.name)
        })
    }

    // Changing the country preselects the first state of that country and the
    // first city of that state, so the dependent dropdowns are never left stale.
    const handleCountryChange = (country, setFieldValue) => {
        setCountryid(country)
        setFieldValue('country_id', country)
        setstateid(EMPTY_LOCATION)
        setcityid(EMPTY_LOCATION)
        setFieldValue('state_id', '')
        setFieldValue('city_id', '')
        setCityName('')
        if (!country?.id) {
            return
        }
        GetState(country.id).then(states => {
            const firstState = states && states.length ? states[0] : null
            if (!firstState) {
                return
            }
            setstateid(firstState)
            setFieldValue('state_id', firstState)
            return selectFirstCity(country.id, firstState.id, setFieldValue)
        }).catch(error => {
            console.log("error=====>", error)
        })
    }

    // Same idea one level down: a new state preselects its first city.
    const handleStateChange = (state, setFieldValue) => {
        setstateid(state)
        setFieldValue('state_id', state)
        setcityid(EMPTY_LOCATION)
        setFieldValue('city_id', '')
        setCityName('')
        Promise.resolve(selectFirstCity(countryid?.id, state?.id, setFieldValue)).catch(error => {
            console.log("error=====>", error)
        })
    }

    const getMenus = (brand_id) => {
        if (!brand_id) {
            return
        }
        getAllMenus({ brand_id: brand_id }).then(data => {
            setMenus(data && data.data && data.data.response ? data.data.response : [])
        }).catch(error => {
            console.log("error=====>", error)
        })
    }

    const nextStep = (selected) => {
        setPage(page + 1);
        var currentStepNum = $('#checkout-progress').data('current-step');
        var nextStepNum = (currentStepNum + 1);
        var currentStep = $('.step.step-' + currentStepNum);
        var nextStep = $('.step.step-' + nextStepNum);
        var progressBar = $('#checkout-progress');
        $('.btn-prev').show();
        $('#section' + currentStepNum).toggle();
        $('#section' + nextStepNum).toggle();
        if (nextStepNum == 6) {
            $(this).toggle();
            $('.btn-next').hide();
        }

        $('.checkout-progress').removeClass('.step-' + currentStepNum).addClass('.step-' + (currentStepNum + 1));

        currentStep.removeClass('active').addClass('valid');
        currentStep.find('span').addClass('opaque');
        currentStep.find('.fa.fa-check').removeClass('opaque');

        nextStep.addClass('active');
        progressBar.removeAttr('class').addClass('step-' + nextStepNum).data('current-step', nextStepNum);
    }

    const prevStep = (selected) => {
        setPage(page - 1);
        var currentStepNum = $('#checkout-progress').data('current-step');
        var prevStepNum = (currentStepNum - 1);
        var currentStep = $('.step.step-' + currentStepNum);
        var prevStep = $('.step.step-' + prevStepNum);
        var progressBar = $('#checkout-progress');
        $('.btn-next').removeClass('disabled');
        $('#section' + currentStepNum).toggle();
        $('#section' + prevStepNum).toggle();
        if (currentStepNum == 6) {
            $('.btn-next').toggle();
        }

        if (prevStepNum > 1) {
            $('.btn-prev').show();
        } else {
            $('.btn-prev').hide(); // Hide only if it's step 1
        }

        if (prevStepNum == 1) {
            $(this).addClass('disabled');
        }
        $('.checkout-progress').removeClass('.step-' + currentStepNum).addClass('.step-' + (prevStepNum));

        currentStep.removeClass('active');
        prevStep.find('span').removeClass('opaque');
        prevStep.find('.fa.fa-check').addClass('opaque');

        prevStep.addClass('active').removeClass('valid');
        progressBar.removeAttr('class').addClass('step-' + prevStepNum).data('current-step', prevStepNum);
    };
    const [btnHide, setBtnHide] = useState(false)

    // change hardware Used
    const hardwareUsed = (selected, index, value, hide) => {

        var dataId = selected.target.getAttribute('data-id');
        $('.hardware_tab_' + dataId).hide();
        var hardwareType = selected.target.value;
        $('.hardware_' + hardwareType + '_' + dataId).show();

        handleChangeData(selected, index, value);
        // if (hide === 'swipe_machine' || hide === 'cash_drawer') {
        //     setBtnHide(true)
        // } else {
        //     setBtnHide(false)
        // }
    };

    const updateHardwareDetail = (id, updatedDetail) => {
        setHardwareDetail(prevHardwareDetail => ({
            ...prevHardwareDetail,
            [id]: updatedDetail
        }));
    };

    const [routingGroupList, setRoutingGroupList] = useState([])

    const getRoutingGroups = (brand_id) => {
        if (!brand_id) {
            return;
        }
        const formData = new FormData()
        formData.append('brand_id', brand_id);
        ListGroups(formData).then(data => {
            setRoutingGroupList(data.data.response?.rows || []);
        }).catch(error => {
            console.log("error ====> ", error);
        })
    }
    const handleChangeData = (e, id, field, value) => {

        if(field == 'hardware_used'){
            if(e.target.value == 'swipe_machine'){
                setSwipeMachineIndex(id);
            }else if(hardwareDetail[id][field] == 'swipe_machine' || swipeMachineIndex == id){
                setSwipeMachineIndex(-1);
            }
        }

        if (field === 'routing_groups') {
            updateHardwareDetail(id, { ...hardwareDetail[id], [field]: value });
        } else {
            let newValue = e.target.value;
            updateHardwareDetail(id, { ...hardwareDetail[id], [field]: newValue });
        }
    };


    const handleDinnerMenu = (e, id, field, menuIndex) => {
        let selectedMenu = e.target.value;
        selectedMenu = parseInt(selectedMenu, 10);
        updateHardwareDetail(id, { ...hardwareDetail[id], [field]: selectedMenu });
    };


    const addMore = (selected) => {
        setAddMoreCount(prevValues => [...prevValues, 1]);

        const newId = Object.keys(hardwareDetail).length + 1;
        const hasMainCashier = Object.values(hardwareDetail).some(
            d => d.hardware_used === 'pos' && d.is_main_cashier
        );
        // updateHardwareDetail(newId, { hardware_used: 'printer', printer_type: 'customer', printer_ip: null, routing_groups: null, registration_id: null, name: null, sdk_id: null, select_menu: null, swipe_machine : 'manual' });
        updateHardwareDetail(
            newId,
            {
                hardware_used: 'pos',
                // printer_type: 'customer', //to be remove
                // printer_ip: null, //to be remove
                routing_groups: null,
                registration_id: null,
                name: null,
                // sdk_id: null, //to be remove
                select_menu: null,
                swipe_machine : 'manual',
                customer_printer_name : null,
                customer_printer_ip : null,
                kitchen_printer_name : null,
                kitchen_printer_ip : null,
                kitchen_device_name : null,
                kitchen_device_registration_id : null,
                is_main_cashier: !hasMainCashier
            }
        );

    }


    const [activeStep, setActiveStep] = useState(1);

    // Function to handle step changes — jump directly to any tab in one click.
    const handleStepChange = (step) => {
        // show only the chosen section, hide the rest
        for (let i = 1; i <= 6; i++) {
            $('#section' + i).css('display', i === step ? 'block' : 'none');
        }
        // keep the hidden jQuery stepper in sync so Back / Next continue from here
        $('#checkout-progress').removeAttr('class').addClass('step-' + step).data('current-step', step);
        // Back hidden on the first step, Next hidden on the last step
        step === 1 ? $('.btn-prev').hide() : $('.btn-prev').show();
        step === 6 ? $('.btn-next').hide() : $('.btn-next').show();
        setActiveStep(step);
    };
    const removeLast = () => {
        if (addMoreCount.length <= 1) return;

        setAddMoreCount((prevValues) => prevValues.slice(0, -1));

        setHardwareDetail((prevHardwareDetail) => {
            const newHardwareDetail = { ...prevHardwareDetail };
            const lastKey = Object.keys(newHardwareDetail).length;
            delete newHardwareDetail[lastKey];
            return newHardwareDetail;
        });
    };

    const options = (routingGroupList || []).map((option) => ({
        key: option.id,
        text: capitalizeAllFirstLetters(option.name),
        value: option.id,
    }));
    function validateOpeningTime(errors, values) {
        storeTime.forEach(item => {
            if (values[`is_${item.value}`]) {
                if (values[`${item.value}_opening_time`] && values[`${item.value}_closing_time`]) {
                    // any opening/closing time combination is allowed (open & close can even be the same)
                    delete errors[`is_${item.value}`];
                    // const [hours, minutes] = values[`${item.value}_closing_time`].split(":");
                    // const [hours2, minutes2] = values[`${item.value}_opening_time`].split(":");
                    // const date = new Date();
                    // const date2 = new Date();
                    // date.setHours(hours);
                    // date.setMinutes(minutes);
                    // date2.setHours(hours2);
                    // date2.setMinutes(minutes2);
                    // let diff = (date.getTime() - date2.getTime()) / 1000 / 60;
                    // const timeGap = 5;
                    // if (Math.abs(diff) >= timeGap) {
                    //     delete errors[`is_${item.value}`];
                    // } else {
                    //     errors[`is_${item.value}`] = `Opening time and closing time should be within ${timeGap} minutes gap.`;
                    // }
                } else {
                    errors[`is_${item.value}`] = `Please select opening and closing time`;
                }
            } else {
                delete errors[`is_${item.value}`];
            }
        });
    }

    const handleAdd = (values, setFieldValue) => {
        setFieldValue('dine_tables', [
            ...values.dine_tables,
            { table_number: '', table_name: '' },
        ]);
    };

    const handleRemove = (values, index, setFieldValue) => {
        setFieldValue(
            'dine_tables',
            values.dine_tables.filter((_, i) => i !== index)
        );
    };

    const clearAll = () => {
        setAddMoreCount([]);
        setHardwareDetail([]);
        setRoutingGroup([]);
    };

    useEffect(() => {
        let ErrorObj = {}
        Object.entries(hardwareDetail).forEach(([index, details]) => {
           
            if (details.hardware_used == "kitchen") {
                if (!details.kitchen_device_name || !details.kitchen_device_registration_id || !details.routing_groups || !details.routing_groups.length ) {
                    ErrorObj[index] = true
                }
            }else if (details.hardware_used == "pos") {
                if (!details.name || !details.registration_id || !details.select_menu || !details.customer_printer_name ||
                    !details.customer_printer_ip || !details.kitchen_printer_name || !details.kitchen_printer_ip ||
                    !details.zatca_configuration_id
                ) {
                    ErrorObj[index] = true
                }
            }else if (details.hardware_used == "swipe_machine") {
                if (!details.swipe_machine) {
                    ErrorObj[index] = true
                }
            }
            
        })
        // Duplicate ZATCA config check across POS devices
        const zatcaIds = Object.entries(hardwareDetail)
            .filter(([, d]) => d.hardware_used === 'pos' && d.zatca_configuration_id)
            .map(([, d]) => d.zatca_configuration_id);
        const duplicateZatcaIds = zatcaIds.filter((id, i) => zatcaIds.indexOf(id) !== i);
        if (duplicateZatcaIds.length > 0) {
            Object.entries(hardwareDetail).forEach(([index, details]) => {
                if (details.hardware_used === 'pos' && duplicateZatcaIds.includes(details.zatca_configuration_id)) {
                    ErrorObj[index] = true;
                }
            });
        }
        setHardwareError(ErrorObj);
        if (Object.entries(ErrorObj).length > 0 && page == 2) {
            setBtnDisable(true);
        } else {
            setBtnDisable(false);
        }
    }, [hardwareDetail, page]);

    const modifyObjectHardwareDetail = () => {
        const modifiedObj = {};
        for (const key in hardwareDetail) {
           
            if (hardwareDetail[key].hardware_used === "kitchen") {
                modifiedObj[key] = {
                    id: hardwareDetail[key].id,
                    hardware_used: hardwareDetail[key].hardware_used,
                    kitchen_device_name : hardwareDetail[key].kitchen_device_name,
                    kitchen_device_registration_id : hardwareDetail[key].kitchen_device_registration_id,
                    routing_groups : hardwareDetail[key].routing_groups 
                };
            } else if (hardwareDetail[key].hardware_used === "pos") {
                modifiedObj[key] = {
                    ...hardwareDetail[key],
                    swipe_machine : null,
                    kitchen_device_name : null,
                    kitchen_device_registration_id : null,
                    routing_groups : null
                };
            } else if(hardwareDetail[key].hardware_used === "swipe_machine") {
                modifiedObj[key] = {
                    id: hardwareDetail[key].id,
                    hardware_used: hardwareDetail[key].hardware_used,
                    swipe_machine : hardwareDetail[key].swipe_machine
                };
            }
        }
        return modifiedObj;
    };

    const [isValidationTriggered, setIsValidationTriggered] = useState(false);

    // ZATCA configurations (device-level)
    const [deviceZatcaList, setDeviceZatcaList] = useState([]);
    const [showAddZatcaForm, setShowAddZatcaForm] = useState(false);
    const [zatcaRegMethod, setZatcaRegMethod] = useState('otp');
    const [deviceZatcaFile, setDeviceZatcaFile] = useState(null);
    const [deviceZatcaLoading, setDeviceZatcaLoading] = useState(false);
    const deviceZatcaFileRef = useRef();
    const [deviceZatcaForm, setDeviceZatcaForm] = useState({
        configuration_name: '', configuration_type: '', zatca_environment_type: '',
        vat_name: '', vat_number: '', organisation_unit_name: '', postal_zone: '',
        street: '', building: '', plot_identification: '', city_subdivision: '', city: '', otp: ''
    });
    const [deviceZatcaErrors, setDeviceZatcaErrors] = useState({});
    const [viewZatcaModal, setViewZatcaModal] = useState(false);
    const [viewZatcaRecord, setViewZatcaRecord] = useState(null);
    const [reUploadZatcaConfig, setReUploadZatcaConfig] = useState(null);

    const fetchDeviceZatcaList = () => {
        GetZatcaConfigurationsList({ outlet_id: params.id }).then(data => {
            setDeviceZatcaList(data?.data?.response || []);
        }).catch(err => console.log(err));
    };

    const handleRegisterAgain = (cfg) => {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Register Again to ZATCA?',
            text: `This will re-register "${cfg.configuration_name}" with ZATCA.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Register',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                setDeviceZatcaLoading(true);
                const formData = new FormData();
                formData.append('id', cfg.id);
                registerToZatcaAgain(formData).then((response) => {
                    if (response?.status === 200) {
                        Swal.fire({ customClass: 'swal-wide', icon: 'success', title: response?.data?.message || 'Registered successfully', showConfirmButton: false, timer: 2000, toast: true, position: 'top-right' });
                        fetchDeviceZatcaList();
                    } else {
                        Swal.fire({ customClass: 'swal-wide', icon: 'error', title: response?.data?.message || 'Registration failed', showConfirmButton: false, timer: 3000, toast: true, position: 'top-right' });
                    }
                }).catch(() => {
                    Swal.fire({ customClass: 'swal-wide', icon: 'error', title: 'An error occurred', showConfirmButton: false, timer: 3000, toast: true, position: 'top-right' });
                }).finally(() => {
                    setDeviceZatcaLoading(false);
                });
            }
        });
    };

    const handleSubmitDeviceZatca = async () => {
        const errors = {};
        if (!deviceZatcaForm.configuration_name?.trim()) errors.configuration_name = 'Configuration name is required';
        if (!deviceZatcaForm.configuration_type) errors.configuration_type = 'Configuration type is required';
        if (deviceZatcaForm.configuration_type === 'online' && deviceZatcaList.some(cfg => cfg.configuration_type === 'online')) {
            errors.configuration_type = 'An online configuration already exists. Only one online configuration is allowed per outlet.';
        }
        if (!deviceZatcaForm.zatca_environment_type) errors.zatca_environment_type = 'Environment type is required';
        if (zatcaRegMethod === 'otp') {
            if (!deviceZatcaForm.vat_name?.trim()) errors.vat_name = 'Organization name is required';
            if (!deviceZatcaForm.vat_number?.trim()) errors.vat_number = 'VAT number is required';
            if (!deviceZatcaForm.organisation_unit_name?.trim()) errors.organisation_unit_name = 'Organization unit name is required';
            if (!deviceZatcaForm.postal_zone?.trim()) errors.postal_zone = 'Postal zone is required';
            if (!deviceZatcaForm.street?.trim()) errors.street = 'Street is required';
            if (!deviceZatcaForm.building?.trim()) errors.building = 'Building is required';
            if (!deviceZatcaForm.plot_identification?.trim()) errors.plot_identification = 'Plot identification is required';
            if (!deviceZatcaForm.city_subdivision?.trim()) errors.city_subdivision = 'City subdivision is required';
            if (!deviceZatcaForm.otp?.trim()) errors.otp = 'OTP is required';
        } else {
            if (!deviceZatcaFile) errors.file = 'Certificate file is required';
        }
        if (Object.keys(errors).length > 0) { setDeviceZatcaErrors(errors); return; }
        setDeviceZatcaErrors({});
        setDeviceZatcaLoading(true);
        try {
            const formData = new FormData();
            formData.append('outlet_id', params.id);
            formData.append('configuration_name', deviceZatcaForm.configuration_name);
            formData.append('configuration_type', deviceZatcaForm.configuration_type);
            formData.append('company_id', getCompany().company_id);
            formData.append('zatca_environment_type', deviceZatcaForm.zatca_environment_type);
            if (reUploadZatcaConfig) formData.append('id', reUploadZatcaConfig.id);
            if (zatcaRegMethod === 'otp') {
                formData.append('vat_name', deviceZatcaForm.vat_name);
                formData.append('vat_number', deviceZatcaForm.vat_number);
                formData.append('organisation_unit_name', deviceZatcaForm.organisation_unit_name);
                formData.append('postal_zone', deviceZatcaForm.postal_zone);
                formData.append('street', deviceZatcaForm.street);
                formData.append('building', deviceZatcaForm.building);
                formData.append('plot_identification', deviceZatcaForm.plot_identification);
                formData.append('city_subdivision', deviceZatcaForm.city_subdivision);
                formData.append('city', cityName);
                formData.append('otp', deviceZatcaForm.otp);
            } else {
                formData.append('zatca_certificate', deviceZatcaFile);
            }
            const response = await AddZatcaRegistration(formData);
            if (response?.data?.status === 1 || response?.data?.status === '1') {
                Swal.fire({ customClass: 'swal-wide', icon: 'success', title: response?.data?.message || 'Configuration added successfully', showConfirmButton: false, timer: 2000, toast: true, position: 'top-right' });
                setShowAddZatcaForm(false);
                setDeviceZatcaFile(null);
                setReUploadZatcaConfig(null);
                setDeviceZatcaForm({ configuration_name: '', configuration_type: '', zatca_environment_type: '', vat_name: '', vat_number: '', organisation_unit_name: '', postal_zone: '', street: '', building: '', plot_identification: '', city_subdivision: '', otp: '' });
                fetchDeviceZatcaList();
            } else {
                Swal.fire({ customClass: 'swal-wide', icon: 'error', title: response?.data?.message || 'Registration failed', showConfirmButton: false, timer: 3000, toast: true, position: 'top-right' });
            }
        } catch (error) {
            console.error('ZATCA config error:', error);
            Swal.fire({ customClass: 'swal-wide', icon: 'error', title: 'An error occurred', showConfirmButton: false, timer: 3000, toast: true, position: 'top-right' });
        } finally {
            setDeviceZatcaLoading(false);
        }
    };

    const handleGoToList = () => {
        navigate(`/company/business/outlet/list/${params.pgno}`);
    };

    return (
        <>
            <div className="page-header d-flex align-items-center">
                <div className="page-header-left">
                    <Breadcrums data={breadcrumbs} />
                    {searchParams.get("copy") ?
                        <h4>Outlet</h4>
                        : <h4>{capitalizeFirstLetter(editFormRef?.current?.values?.outlet_name)}</h4>}
                </div>
                <div className="page-header-right ms-auto">

                </div>
            </div>
            <Formik
                enableReinitialize
                validateOnBlur={true}
                innerRef={editFormRef}
                initialValues={{
                    outlet_name: showDefault && showDefault.outlet_name ? showDefault.outlet_name : "",
                    outlet_name_ar: showDefault && showDefault.outlet_name_ar ? showDefault.outlet_name_ar : "",
                    brand_id: showDefault && showDefault.brand_id ? showDefault.brand_id : "",
                    short_code: showDefault && showDefault.short_code ? showDefault.short_code : "",
                    postal_zone: showDefault && showDefault.postal_zone ? showDefault.postal_zone : "",
                    // vat_information: showDefault && showDefault.vat_information ? showDefault.vat_information : "",
                    email: showDefault && showDefault.email ? showDefault.email : "",
                    short_description: showDefault && showDefault.short_description ? showDefault.short_description : "",
                    short_description_ar: showDefault && showDefault.short_description_ar ? showDefault.short_description_ar : "",
                    location: showDefault && showDefault.location ? showDefault.location : "",
                    country_id: showDefault && showDefault.country_id ? showDefault.country_id : "",
                    state_id: showDefault && showDefault.state_id ? showDefault.state_id : "",
                    city_id: showDefault && showDefault.city_id ? showDefault.city_id : "",
                    area: showDefault && showDefault.area_id ? showDefault.area_id : "",
                    street: showDefault && showDefault.street ? showDefault.street : "",
                    building: showDefault && showDefault.building ? showDefault.building : "",
                    plot_identification: showDefault && showDefault.plot_identification ? showDefault.plot_identification : "",
                    city_subdivision: showDefault && showDefault.city_subdivision ? showDefault.city_subdivision : "",
                    invoice_header_text_info: showDefault && showDefault.invoice_header_text_info ? showDefault.invoice_header_text_info : "",
                    invoice_footer_text_info: showDefault && showDefault.invoice_footer_text_info ? showDefault.invoice_footer_text_info : "",
                    end_of_the_day_configuration: showDefault && showDefault.end_of_the_day_configuration ? showDefault.end_of_the_day_configuration : "",
                    end_of_the_day_time: showDefault && showDefault.end_of_the_day_time ? showDefault.end_of_the_day_time : "",
                    is_sunday: showDefault && showDefault.is_sunday ? showDefault.is_sunday : "",
                    is_monday: showDefault && showDefault.is_monday ? showDefault.is_monday : "",
                    is_tuesday: showDefault && showDefault.is_tuesday ? showDefault.is_tuesday : "",
                    is_wednesday: showDefault && showDefault.is_wednesday ? showDefault.is_wednesday : "",
                    is_thursday: showDefault && showDefault.is_thursday ? showDefault.is_thursday : "",
                    is_friday: showDefault && showDefault.is_friday ? showDefault.is_friday : "",
                    is_saturday: showDefault && showDefault.is_saturday ? showDefault.is_saturday : "",
                    sunday_opening_time: showDefault && showDefault.sunday_opening_time ? showDefault.sunday_opening_time : "",
                    monday_opening_time: showDefault && showDefault.monday_opening_time ? showDefault.monday_opening_time : "",
                    tuesday_opening_time: showDefault && showDefault.tuesday_opening_time ? showDefault.tuesday_opening_time : "",
                    wednesday_opening_time: showDefault && showDefault.wednesday_opening_time ? showDefault.wednesday_opening_time : "",
                    thursday_opening_time: showDefault && showDefault.thursday_opening_time ? showDefault.thursday_opening_time : "",
                    friday_opening_time: showDefault && showDefault.friday_opening_time ? showDefault.friday_opening_time : "",
                    saturday_opening_time: showDefault && showDefault.saturday_opening_time ? showDefault.saturday_opening_time : "",
                    sunday_closing_time: showDefault && showDefault.sunday_closing_time ? showDefault.sunday_closing_time : "",
                    monday_closing_time: showDefault && showDefault.monday_closing_time ? showDefault.monday_closing_time : "",
                    tuesday_closing_time: showDefault && showDefault.tuesday_closing_time ? showDefault.tuesday_closing_time : "",
                    wednesday_closing_time: showDefault && showDefault.wednesday_closing_time ? showDefault.wednesday_closing_time : "",
                    thursday_closing_time: showDefault && showDefault.thursday_closing_time ? showDefault.thursday_closing_time : "",
                    friday_closing_time: showDefault && showDefault.friday_closing_time ? showDefault.friday_closing_time : "",
                    saturday_closing_time: showDefault && showDefault.saturday_closing_time ? showDefault.saturday_closing_time : "",
                    copy_print_count: showDefault && showDefault.copy_print_count ? showDefault.copy_print_count : "",
                    service_type: showDefault && showDefault.service_type ? showDefault.service_type : "",
                    dine_tables: showDefault && showDefault.dine_tables ? showDefault.dine_tables : [{ table_number: '', table_name: '' }],
                    erp_configuration: showDefault && showDefault.erp_configuration ? showDefault.erp_configuration :
                        { dimension_value_1: '', dimension_value_2: '', dimension_value_3: '', dimension_value_4: '', dimension_value_5: '', dimension_value_6: '', card_offset_value: '' , cash_offset_value : '' },
                    zatca_environment_type: showDefault && showDefault.zatca_environment_type ? showDefault.zatca_environment_type : "",
                    // vat_name: showDefault && showDefault.vat_name ? showDefault.vat_name : "",
                    // vat_number: showDefault && showDefault.vat_number ? showDefault.vat_number : "",
                    // organisation_unit_name: showDefault && showDefault.organisation_unit_name ? showDefault.organisation_unit_name : "",
                }}
                validate={values => {
                    const error = {};
                    // if (!values.vat_information?.trim()) {
                    //     error.vat_information = "VAT Information is required";
                    // } else if (!/^\d+$/.test(values.vat_information)) {
                    //     error.vat_information = "VAT Information should be numeric only";
                    // } else if (values.vat_information.length !== 15) {
                    //     error.vat_information = "VAT Information should be of 15 digits";
                    // }

                    if (!values.outlet_name.trim()) error.outlet_name = "Name is required";
                    if (values.outlet_name.trim().length > 60) error.outlet_name = "Name should not exceed 60 characters";
                    if (!values.outlet_name_ar.trim()) error.outlet_name_ar = "Name is required";
                    if (values.outlet_name_ar.trim().length > 60) error.outlet_name_ar = "Name (Arabic) should not exceed 60 characters";
                    if (values.short_code.trim().length > 60) {
                        error.short_code = "Short code should not exceed 60 characters";
                    }

                    if (!values.country_id) {
                        error.country_id = "Country is required";
                    }
                    if (!values.state_id) {
                        error.state_id = "State is required";
                    }
                    if (!values.area) {
                        error.area = "Area is required";
                    }

                    if (values.invoice_footer_text_info.trim().length > 250) {
                        error.invoice_footer_text_info = "Invoice footer text should not exceed 250 characters";
                    }
                    if (values.invoice_header_text_info.trim().length > 250) {
                        error.invoice_header_text_info = "Invoice header text should not exceed 250 characters";
                    }
                    if (!values.copy_print_count) {
                        error.copy_print_count = 'Please enter a number value';
                    } else if (!Number.isInteger(parseInt(values.copy_print_count))) {
                        error.copy_print_count = 'Please enter a valid number';
                    } else if (parseInt(values.copy_print_count) < 0) {
                        error.copy_print_count = 'Please enter a non-negative number';
                    } else if (parseInt(values.copy_print_count) > 250) {
                        error.copy_print_count = 'Copy print count should not exceed 250';
                    } else if (!Number.isInteger(parseFloat(values.copy_print_count))) {
                        error.copy_print_count = "Copy print count must be a whole number";
                    }

                    if (!values.email) {
                        error.email = "Email is required";
                    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
                        error.email = 'Invalid email address';
                    }
                    //  else if (/[?+]/.test(values.email)) {
                    //     error.email = 'Invalid email address';
                    // }
                    if (page == 1) {
                        if (error.outlet_name || error.outlet_name_ar || error.country_id || error.state_id ||
                            error.brand_id || error.email || error.area) {
                            
                            setBtnDisable(true);
                        } else {
                            setBtnDisable(false);
                        }
                    }
                    if (values.short_description.trim().length > 200) {
                        error.short_description = "Short description must be 200 characters or less";
                    }
                    if (values.short_description_ar.trim().length > 200) {
                        error.short_description_ar = "Short description arabic must be 200 characters or less";
                    }
                    if (values.location.trim().length > 200) {
                        error.location = "location must be 200 characters or less";
                    }
                    if (!values.service_type) {
                        error.service_type = "Service type is required";
                    }
                    values?.dine_tables?.forEach((val, idx) => {
                        if (values.service_type === 'table_service') {
                            if (!val?.table_number?.trim()) {
                                error[`dine_tables[${idx}].table_number`] = "Table number is required";
                            }
                            else if (val?.table_number?.length > 15) {
                                error[`dine_tables[${idx}].table_number`] = "Table number should not exceed 15 characters";
                            }

                            if (!val?.table_name?.trim()) {
                                error[`dine_tables[${idx}].table_name`] = "Table name is required";
                            } else if (val?.table_name?.trim()?.length >= 25) {
                                error[`dine_tables[${idx}].table_name`] = "Table name should not exceed 25 characters";
                            }
                        }
                    });

                    // if (values?.erp_configuration) {
                    //     if (!values.erp_configuration?.dimension_value_1?.trim()) {
                    //         error.dimension_value_1 = "Dimension Value 1 is required";
                    //     } else if (values.erp_configuration?.dimension_value_1?.length > 50) {
                    //         error.dimension_value_1 = "Dimension Value 1 should not exceed 50 characters";
                    //     }

                    //     if (!values.erp_configuration?.dimension_value_2?.trim()) {
                    //         error.dimension_value_2 = "Dimension Value 2 is required";
                    //     } else if (values.erp_configuration?.dimension_value_2?.length > 50) {
                    //         error.dimension_value_2 = "Dimension Value 2 should not exceed 50 characters";
                    //     }

                    //     if (!values.erp_configuration?.dimension_value_3?.trim()) {
                    //         error.dimension_value_3 = "Dimension Value 3 is required";
                    //     } else if (values.erp_configuration?.dimension_value_3?.length > 50) {
                    //         error.dimension_value_3 = "Dimension Value 3 should not exceed 50 characters";
                    //     }

                    //     if (!values.erp_configuration?.dimension_value_4?.trim()) {
                    //         error.dimension_value_4 = "Dimension Value 4 is required";
                    //     } else if (values.erp_configuration?.dimension_value_4?.length > 50) {
                    //         error.dimension_value_4 = "Dimension Value 4 should not exceed 50 characters";
                    //     }

                    //     if (!values.erp_configuration?.dimension_value_5?.trim()) {
                    //         error.dimension_value_5 = "Dimension Value 5 is required";
                    //     } else if (values.erp_configuration?.dimension_value_5?.length > 50) {
                    //         error.dimension_value_5 = "Dimension Value 5 should not exceed 50 characters";
                    //     }

                    //     if (!values.erp_configuration?.dimension_value_6?.trim()) {
                    //         error.dimension_value_6 = "Dimension Value 6 is required";
                    //     } else if (values.erp_configuration?.dimension_value_6?.length > 50) {
                    //         error.dimension_value_6 = "Dimension Value 6 should not exceed 50 characters";
                    //     }
                    // }

                    validateOpeningTime(error, values);

                    return error;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitted(true);
                    let formData = new FormData();
                    formData.append('outlet_name', values.outlet_name);
                    formData.append('outlet_name_ar', values.outlet_name_ar);
                    formData.append('brand_id', values.brand_id);
                    formData.append('short_code', values.short_code);
                    formData.append('email', values.email);
                    formData.append('short_description', values.short_description);
                    formData.append('short_description_ar', values.short_description_ar);
                    formData.append('location', values.location);
                    formData.append('city_id', JSON.stringify(values.city_id));
                    formData.append('state_id', JSON.stringify(values.state_id));
                    formData.append('country_id', JSON.stringify(values.country_id));
                    formData.append('area', values.area);

                    formData.append('hardware_details', JSON.stringify(modifyObjectHardwareDetail()));

                    formData.append('invoice_header_text_info', values.invoice_header_text_info);
                    formData.append('invoice_footer_text_info', values.invoice_footer_text_info);
                    formData.append('end_of_the_day_configuration', selectedOption);
                    formData.append('end_of_the_day_time', values.end_of_the_day_time);
                    formData.append('is_sunday', values.is_sunday ? values.is_sunday : '');
                    formData.append('is_monday', values.is_monday ? values.is_monday : '');
                    formData.append('is_tuesday', values.is_tuesday ? values.is_tuesday : '');
                    formData.append('is_wednesday', values.is_wednesday ? values.is_wednesday : '');
                    formData.append('is_thursday', values.is_thursday ? values.is_thursday : '');
                    formData.append('is_friday', values.is_friday ? values.is_friday : '');
                    formData.append('is_saturday', values.is_saturday ? values.is_saturday : '');
                    formData.append('sunday_opening_time', values.sunday_opening_time);
                    formData.append('monday_opening_time', values.monday_opening_time);
                    formData.append('tuesday_opening_time', values.tuesday_opening_time);
                    formData.append('wednesday_opening_time', values.wednesday_opening_time);
                    formData.append('thursday_opening_time', values.thursday_opening_time);
                    formData.append('friday_opening_time', values.friday_opening_time);
                    formData.append('saturday_opening_time', values.saturday_opening_time);
                    formData.append('sunday_closing_time', values.sunday_closing_time);
                    formData.append('monday_closing_time', values.monday_closing_time);
                    formData.append('tuesday_closing_time', values.tuesday_closing_time);
                    formData.append('wednesday_closing_time', values.wednesday_closing_time);
                    formData.append('thursday_closing_time', values.thursday_closing_time);
                    formData.append('friday_closing_time', values.friday_closing_time);
                    formData.append('saturday_closing_time', values.saturday_closing_time);
                    formData.append('copy_print_count', Math.floor(values.copy_print_count));
                    
                    formData.append('service_type', values.service_type);
                    if (values.service_type == 'table_service') {
                        formData.append('dine_tables', JSON.stringify(values.dine_tables));
                    }

                    formData.append("erp_configuration", JSON.stringify(values.erp_configuration));

                    formData.append('company_id', getCompany().company_id);

                    if (!searchParams.get('copy')) {
                        formData.append("id", params.id)
                        GetEditOutlet(formData).then(response => {
                            setSubmitting(false);
                            setSubmitted(false);
                            if (response.data.status === 1 || response.data.status === "1") {
                                Swal.fire({
                                    customClass: 'swal-wide',
                                    icon: 'success',
                                    title: response.data.message,
                                    showConfirmButton: false,
                                    timer: 1500,
                                    toast: true,
                                    position: 'top-right',
                                });
                                const evt = new CustomEvent('outlet-list-modified', { detail: {} });
                                document.dispatchEvent(evt);
                                setTimeout(() => {
                                    navigate(`/company/business/outlet/list/${params.pgno}`)
                                }, 1000);
                            } else {
                                Swal.fire({
                                    customClass: 'swal-wide',
                                    icon: 'error',
                                    title: response.data.message,
                                    showConfirmButton: false,
                                    timer: 5000,
                                    toast: true,
                                    position: 'top-right',
                                })
                                setSubmitted(false)
                            }
                        }).catch(error => {
                            console.log("error ====> ", error);
                        })
                    } else {
                        CreateOutlet(formData).then(response => {
                            setSubmitting(false);
                            setSubmitted(false);
                            if (response.data.status === 1 || response.data.status === "1") {
                                Swal.fire({
                                    customClass: 'swal-wide',
                                    icon: 'success',
                                    title: response.data.message,
                                    showConfirmButton: false,
                                    timer: 1500,
                                    toast: true,
                                    position: 'top-right',
                                });
                                const evt = new CustomEvent('outlet-list-modified', { detail: {} });
                                document.dispatchEvent(evt);
                                setTimeout(() => {
                                    navigate(`/company/business/outlet/list/${params.pgno}`)
                                }, 1000);
                            } else {
                                Swal.fire({
                                    customClass: 'swal-wide',
                                    icon: 'error',
                                    title: response.data.message,
                                    showConfirmButton: false,
                                    timer: 5000,
                                    toast: true,
                                    position: 'top-right',
                                })
                                setSubmitted(false)
                            }
                        }).catch(error => {
                            console.log("error ====> ", error);
                        })
                    }

                }}
            >{({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
            }) => (
                <form onSubmit={handleSubmit}>
                    <div className='steps' data-current-step={activeStep}>
                        <ul>
                            <li className={`step step-1 ${activeStep >= 1 ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleStepChange(1)}>
                                <span>1</span><p>Outlet Info</p>
                            </li>
                            <li className={`step step-2 ${activeStep >= 2 ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleStepChange(2)}>
                                <span>2</span><p>Hardware Details</p>
                            </li>
                            <li className={`step step-3 ${activeStep >= 3 ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleStepChange(3)}>
                                <span>3</span><p>Store Settings</p>
                            </li>
                            <li className={`step step-4 ${activeStep >= 4 ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleStepChange(4)}>
                                <span>4</span><p>Outlet Service</p>
                            </li>
                            <li className={`step step-5 ${activeStep >= 5 ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleStepChange(5)}>
                                <span>5</span><p>ERP Configuration</p>
                            </li>
                            <li className={`step step-6 ${activeStep >= 6 ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleStepChange(6)}>
                                <span>6</span><p>Zatca Details</p>
                            </li>
                        </ul>
                    </div>
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className='row row-sm'>
                                <div className="step-1" id="checkout-progress" data-current-step="1" style={{ display: 'none', padding: '0' }}>
                                    <div className="progress-bar">
                                        <div className="step step-1 active"><span> 1</span>
                                            <div className="fa fa-check opaque"></div>
                                            <div className="step-label"> Outlet Info</div>
                                        </div>
                                        <div className="step step-2"><span> 2</span>
                                            <div className="fa fa-check opaque"></div>
                                            <div className="step-label"> Hardware Details</div>
                                        </div>
                                        <div className="step step-3"><span> 3</span>
                                            <div className="fa fa-check opaque"></div>
                                            <div className="step-label"> Store Settings</div>
                                        </div>
                                        <div className="step step-4"><span> 4</span>
                                            <div className="fa fa-check opaque"></div>
                                            <div className="step-label"> Outlet Service</div>
                                        </div>
                                        <div className="step step-5"><span> 5</span>
                                            <div className="fa fa-check opaque"></div>
                                            <div className="step-label">ERP Configuration</div>
                                        </div>
                                        <div className="step step-6"><span> 6</span>
                                            <div className="fa fa-check opaque"></div>
                                            <div className="step-label">Zatca Details </div>
                                        </div>
                                    </div>
                                </div>
                                <section id="section1" className="section1 " style={{ display: 'block' }}>
                                    <div className='row'>
                                        <div className='col-lg-6 text-center form-group'>
                                            <label htmlFor='outlet_name' className='text-left d-flex'>Outlet Name <span className="requirestar">*</span></label>
                                            <input name='outlet_name' id="outlet_name" placeholder='Enter outlet name' type='text' onChange={handleChange} onBlur={handleBlur} value={values.outlet_name} className='form-control' autoComplete='off' />
                                            <span className='text-danger d-flex text-left'>{errors.outlet_name && touched.outlet_name && errors.outlet_name}</span>
                                        </div>
                                        <div className='col-lg-6 text-center form-group'>
                                            <label htmlFor='outlet_name_ar' className='text-left d-flex'>Outlet Name (Arabic) <span className="requirestar">*</span></label>
                                            <input name='outlet_name_ar' id="outlet_name_ar" placeholder='Enter outlet name (Arabic)' type='text' onChange={handleChange} onBlur={handleBlur} value={values.outlet_name_ar} className='form-control' autoComplete='off' />
                                            <span className='text-danger d-flex text-left'>{errors.outlet_name_ar && touched.outlet_name_ar && errors.outlet_name_ar}</span>
                                        </div>
                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='brand_id' className='text-left d-flex'>Brand <span className="requirestar">*</span></label>
                                            <select
                                                id="brand_id"
                                                className='form-control'
                                                name='brand_id'
                                                onChange={(event) => {
                                                    handleChange(event);
                                                    setFieldValue('area', '');
                                                    setFieldValue('select_menu', '');
                                                    setFieldValue('routing_groups', '');
                                                    const selectedValue = event.target.value;
                                                    if (selectedValue) {
                                                        getRoutingGroups(selectedValue);
                                                        getArea(selectedValue);
                                                        getMenus(selectedValue)
                                                    }
                                                }}
                                                onBlur={handleBlur}>
                                                <option value=''>Select Brand</option>
                                                {brandList?.length ? brandList?.map((row) => (
                                                    <option value={row.id} selected={values?.brand_id == row.id ? 'selected' : ''}>{capitalizeAllFirstLetters(row?.name)}</option>
                                                )) : ''}
                                            </select>
                                        </div>
                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='short_code' className='text-left d-flex'>Shortcode </label>
                                            <input name='short_code' id="short_code" type='text' onChange={handleChange} onBlur={handleBlur} value={values.short_code} className='form-control' placeholder='Enter Shortcode' autoComplete='off' />
                                            <span className='text-danger d-flex text-left'>{errors.short_code && touched.short_code && errors.short_code}</span>
                                        </div>
                                        {/* <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='vat_information' className='text-left d-flex'>VAT information <span className="requirestar">*</span></label>
                                            <input name='vat_information' id="vat_information" type='text' onChange={handleChange} onBlur={handleBlur} value={values.vat_information} className='form-control' placeholder='Enter VAT information' autoComplete='off' />
                                            <span className='text-danger d-flex text-left'>{errors.vat_information && touched.vat_information && errors.vat_information}</span>
                                        </div> */}
                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='email' className='text-left d-flex'>Email <span className="requirestar">*</span></label>
                                            <input name='email' id="email" type='text' onChange={handleChange} onBlur={handleBlur} value={values.email} className='form-control' placeholder='Enter Email' autoComplete='off' />
                                            <span className='text-danger d-flex text-left'>{errors.email && touched.email && errors.email}</span>
                                        </div>
                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='location' className='text-left d-flex'>Location </label>
                                            <input name='location' id="location" placeholder='Enter location' type='text' onChange={handleChange} onBlur={handleBlur} value={values.location} className='form-control' autoComplete='off' />
                                            <span className='text-danger d-flex text-left'>{errors.location && touched.location && errors.location}</span>
                                        </div>
                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='short_description' className='text-left d-flex'>Short description  </label>
                                            <textarea name='short_description' placeholder='Enter short description' id="short_description" rows="2" type='text' onChange={handleChange} onBlur={handleBlur} value={values.short_description} className='form-control' />
                                            <span className='text-danger d-flex text-left'>{errors.short_description && touched.short_description && errors.short_description}</span>
                                        </div>
                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='short_description_ar' className='text-left d-flex'>Short description (Arabic)  </label>
                                            <textarea name='short_description_ar' placeholder='Enter short description (Arabic)' id="short_description_ar" rows="2" type='text' onChange={handleChange} onBlur={handleBlur} value={values.short_description_ar} className='form-control' />
                                            <span className='text-danger d-flex text-left'>{errors.short_description_ar && touched.short_description_ar && errors.short_description_ar}</span>
                                        </div>
                                        <div className='col-lg-2 text-center form-group mt-3'>
                                            <label htmlFor='country_id' className='text-left d-flex'>
                                                Country <span className="requirestar">*</span>
                                            </label>
                                            <CountrySelect
                                                defaultValue={countryid}
                                                onChange={(e) => handleCountryChange(e, setFieldValue)}
                                                onBlur={() => setFieldTouched("country_id", true)}
                                                placeHolder="Select Country"
                                            />
                                            <span className='text-danger d-flex text-left'>
                                                {errors.country_id && touched.country_id && errors.country_id}
                                            </span>
                                        </div>
                                        <div className='col-lg-2 text-center form-group mt-3'>
                                            <label htmlFor='state_id' className='text-left d-flex'>
                                                State <span className="requirestar">*</span>
                                            </label>
                                            <StateSelect
                                                defaultValue={stateid}
                                                countryid={countryid.id}
                                                onChange={(e) => handleStateChange(e, setFieldValue)}
                                                onBlur={() => setFieldTouched("state_id", true)}
                                                placeHolder="Select State"
                                            />
                                            <span className='text-danger d-flex text-left'>
                                                {errors.state_id && touched.state_id && errors.state_id}
                                            </span>
                                        </div>
                                        <div className='col-lg-2 text-center form-group mt-3'>
                                            <label htmlFor='city_id' className='text-left d-flex'>
                                                City
                                            </label>
                                            <CitySelect
                                                countryid={countryid.id}
                                                stateid={stateid.id}
                                                defaultValue={cityid}
                                                onChange={(e) => {
                                                    setcityid(e);
                                                    setFieldValue(`city_id`, e);
                                                    setCityName(e?.name || '');
                                                }}
                                                placeHolder="Select City"
                                            />
                                            <span className='text-danger d-flex text-left'>
                                                {errors.city_id && touched.city_id && errors.city_id}
                                            </span>
                                        </div>
                                        <div className='col-lg-2 text-center form-group mt-3'>
                                            <label htmlFor='area' className='text-left d-flex'>
                                                Area <span className="requirestar">*</span>
                                            </label>
                                            <Select
                                                inputId='area'
                                                name='area'
                                                classNamePrefix='react-select'
                                                placeholder='Search or select area'
                                                isSearchable
                                                options={areaOptions}
                                                value={areaOptions.find(opt => opt.value === values.area) || null}
                                                onChange={(selected) => {
                                                    setFieldValue('area', selected ? selected.value : '')
                                                    setSelectedArea(selected ? { id: selected.value, name: selected.label } : null)
                                                }}
                                                onBlur={() => setFieldTouched('area', true)}
                                                onMenuScrollToBottom={loadMoreAreas}
                                                onInputChange={searchAreas}
                                                isLoading={areaLoading}
                                                loadingMessage={() => 'Loading areas...'}
                                                noOptionsMessage={({ inputValue }) => (
                                                    !values.brand_id
                                                        ? 'Select a brand first'
                                                        : inputValue
                                                            ? `No area matching "${inputValue}"`
                                                            : 'No areas found for this brand'
                                                )}
                                                menuPortalTarget={document.body}
                                                menuPlacement='auto'
                                                maxMenuHeight={240}
                                                styles={areaSelectStyles}
                                            />
                                            <span className='text-danger d-flex text-left'>
                                                {errors.area && touched.area && errors.area}
                                            </span>
                                        </div>

                                    </div>
                                </section>

                                <section id="section2" className="section2 " style={{ display: 'none' }}>
                                    <div className='select_hardware_used_body'>
                                        {addMoreCount.length > 0 && addMoreCount.map((row, index) => (
                                            <div className='select_hardware_used mt-4'>
                                                <div className='row'>
                                                    <div style={{
                                                        borderTop: index >= 1 ? '1px solid gray' : 'none',
                                                        marginTop: index >= 1 ? '40px' : 'none',
                                                        paddingTop: '1rem',
                                                        textAlign: 'left',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        width: '50%',
                                                    }}>
                                                        <label htmlFor='name' className='text-left d-flex mb-2'>
                                                            Select Hardware Used <span className="requirestar">*</span>
                                                        </label>
                                                        <div className='row ps-3'>
                                                            <div className="form-check w-25">
                                                                <input
                                                                    className="form-check-input hardware_used printer cp"
                                                                    onChange={(e) => hardwareUsed(e, index + 1, 'hardware_used', 'kitchen')}
                                                                    type="radio"
                                                                    name={"hardware_used_" + (index + 1)}
                                                                    id={`kitchen_${index + 1}`}
                                                                    value="kitchen"
                                                                    data-id={index + 1}
                                                                    checked={hardwareDetail[index + 1].hardware_used === 'kitchen'}
                                                                    autoComplete='off'
                                                                />
                                                                <label className="form-check-label cp" htmlFor={`kitchen_${index + 1}`}>Kitchen</label>
                                                            </div>
                                                            <div className="form-check w-25">
                                                                <input
                                                                    className="form-check-input hardware_used cp"
                                                                    onChange={(e) => hardwareUsed(e, index + 1, 'hardware_used', 'swipe_machine')}
                                                                    type="radio"
                                                                    name={"hardware_used_" + (index + 1)}
                                                                    id={`swipe_machine_${index + 1}`}
                                                                    value="swipe_machine"
                                                                    data-id={index + 1}
                                                                    checked={hardwareDetail[index + 1].hardware_used === 'swipe_machine'}
                                                                    autoComplete='off'
                                                                    disabled={swipeMachineIndex != (index+1) && swipeMachineIndex != -1}
                                                                />
                                                                <label className="form-check-label cp" htmlFor={`swipe_machine_${index + 1}`}>Swipe Machine</label>
                                                            </div>
                                                            <div className="form-check w-25">
                                                                <input
                                                                    className="form-check-input hardware_used cp"
                                                                    onChange={(e) => hardwareUsed(e, index + 1, 'hardware_used', 'pos')}
                                                                    type="radio"
                                                                    name={"hardware_used_" + (index + 1)}
                                                                    id={`pos_${index + 1}`}
                                                                    value="pos"
                                                                    data-id={index + 1}
                                                                    checked={hardwareDetail[index + 1].hardware_used === 'pos'}
                                                                    autoComplete='off'
                                                                    disabled={!deviceZatcaList.some(cfg => cfg.configuration_type === 'pos')}
                                                                    title={!deviceZatcaList.some(cfg => cfg.configuration_type === 'pos') ? 'Add a POS-type ZATCA configuration first' : ''}
                                                                />
                                                                <label className="form-check-label cp" htmlFor={`pos_${index + 1}`}>POS</label>
                                                            </div>
                                                        </div>
                                                        <span className='text-danger d-flex text-left'>{errors.name && touched.name && errors.name}</span>
                                                    </div>

                                                    <div className='col-lg-6 text-left form-group'></div>
                                                </div>

                                                <div className={' hardware_printer hardware_printer_' + (index + 1) + ' hardware_tab_' + (index + 1)} data-id={index + 1} style={{ display: hardwareDetail[(index + 1)].hardware_used == 'kitchen' ? 'block' : 'none' }}>
                                                    {/* Device Name */}
                                                    <div className="col-lg-6 text-left mt-3 form-group">
                                                        <label htmlFor="name" className="me-2 mb-0">Device Name</label>
                                                        <input name="name" id="name" placeholder="Enter Kitchen Device name" type="text" onChange={(e) => handleChangeData(e, index + 1, "kitchen_device_name")} value={hardwareDetail[index + 1]?.kitchen_device_name || ""} className="form-control" autoComplete="off"/>
                                                    </div>

                                                    {/* Device Id */}
                                                    <div className="col-lg-6 text-left mt-3 form-group">
                                                        <label htmlFor="printer_ip" className="me-2 mb-0">Device Registration ID</label>
                                                        <input name="printer_ip[]" id="printer_ip" placeholder="Enter Kitchen Device ID" type="text" onChange={(e) => handleChangeData(e, index + 1, "kitchen_device_registration_id")} value={hardwareDetail[index + 1]?.kitchen_device_registration_id || ""} className="form-control" autoComplete="off"/>
                                                    </div>
                                                    
                                                    {/* routing groups */}
                                                    <div className='col-lg-6 text-center form-group mt-3'>
                                                        <label htmlFor='registration_id' className='text-left d-flex'>Routing Groups </label>
                                                        <Dropdown
                                                            placeholder="Enter routing groups"
                                                            fluid
                                                            multiple
                                                            selection
                                                            className="routing_groups"
                                                            id={"routing_groups" + index}
                                                            value={hardwareDetail[(index + 1)].routing_groups || []}
                                                            onChange={(e, { value }) => {
                                                                setRoutingGroup(value);
                                                                handleChangeData(e, index + 1, 'routing_groups', value);
                                                            }}
                                                            options={options}
                                                        />
                                                        <span className='text-danger d-flex text-left'>{errors.routing_groups && touched.routing_groups && errors.routing_groups}</span>
                                                    </div>
                                                    <div className='col-lg-6 text-left form-group'></div>
                                                    {/* <div className='row'>
                                                         <div className='col-lg-6 text-left form-group mt-3'>
                                                            <label htmlFor='name' className='text-left d-flex mb-2'>Printer Type <span className="requirestar">*</span></label>
                                                            <div className='row ps-3'>
                                                                <div className="form-check w-25">
                                                                    <input className="form-check-input" type="radio" style={{ cursor: 'pointer' }} name={"printer_type_" + (index + 1)} id="customer" value="customer" onChange={(e) => handleChangeData(e, (index + 1), 'printer_type')} checked={hardwareDetail[(index + 1)].printer_type == 'customer' ? true : ''} autoComplete='off' />
                                                                    <label className="form-check-label" for="customer" style={{ cursor: 'pointer' }}>Customer</label>
                                                                </div>
                                                                <div className="form-check w-25">
                                                                    <input className="form-check-input" type="radio" style={{ cursor: 'pointer' }} name={"printer_type_" + (index + 1)} id="kitchen" value="kitchen" onChange={(e) => handleChangeData(e, (index + 1), 'printer_type')} checked={hardwareDetail[(index + 1)].printer_type == 'kitchen' ? true : ''} autoComplete='off' />
                                                                    <label className="form-check-label" for="kitchen" style={{ cursor: 'pointer' }}>Kitchen</label>
                                                                </div>
                                                            </div>
                                                            <span className='text-danger d-flex text-left'>{errors.name && touched.name && errors.name}</span>
                                                        </div>
                                                        <div className='col-lg-6 text-left form-group'></div>
                                                       
                                                        <div className='col-lg-6 text-center form-group mt-3'>
                                                            <label htmlFor='printer_ip' className='text-left d-flex'>Printer IP</label>
                                                            <input name='printer_ip[]' id="printer_ip" placeholder='Enter printer IP' type='text' onChange={(e) => handleChangeData(e, (index + 1), 'printer_ip')} value={hardwareDetail[(index + 1)].printer_ip} className='form-control' autoComplete='off' />
                                                        </div>
                                                        <div className='col-lg-6 text-left form-group'></div>
                                                        <div className='col-lg-6 text-center form-group mt-3'>
                                                            <label htmlFor='name' className='text-left d-flex'>
                                                                {hardwareDetail[(index + 1)].printer_type == 'customer' ? 'Printer Name' : 'Device Name' }
                                                            </label>
                                                            <input name='name' id="name" placeholder='Enter name' type='text' onChange={(e) => handleChangeData(e, (index + 1), 'name')}
                                                                value={hardwareDetail[(index + 1)].name}
                                                                className='form-control' autoComplete='off' />
                                                        </div>
                                                        <div className='col-lg-6 text-left form-group'></div>
                                                        {
                                                            hardwareDetail[(index + 1)].printer_type == 'kitchen'
                                                                ?
                                                                <>
                                                                    <div className='col-lg-6 text-center form-group mt-3'>
                                                                        <label htmlFor='registration_id' className='text-left d-flex'>Device Registration ID</label>
                                                                        <input name='registration_id[]' id="registration_id" placeholder='Enter registration ID' type='text' onChange={(e) => handleChangeData(e, (index + 1), 'registration_id')} value={hardwareDetail[(index + 1)].registration_id} className='form-control' autoComplete='off' />
                                                                    </div>
                                                                    <div className='col-lg-6 text-left form-group'></div>
                                                                </>
                                                                : null
                                                        } 
                                                        
                                                    </div> */}
                                                </div> 

                                                {/* <div className='col-lg-6 text-center form-group mt-3'>
                                                            <label htmlFor='sdk_id' className='text-left d-flex'>SDK ID </label>
                                                            <input name='sdk_id' id="sdk_id" placeholder='Enter SDK ID' type='text' onChange={(e) => handleChangeData(e, (index + 1), 'sdk_id')} value={hardwareDetail[(index + 1)].sdk_id} className='form-control' autoComplete='off' />
                                                        </div> */}
                                                <div className={' hardware_swipe_machine hardware_swipe_machine_' + (index + 1) + ' hardware_tab_' + (index + 1)} data-id="1" style={{ display: hardwareDetail[(index + 1)].hardware_used == 'swipe_machine' ? 'block' : 'none' }}>
                                                    <div className="row">
                                                        <div className='col-lg-6 text-center form-group mt-3'>
                                                            <label htmlFor='select_menu' className='text-left d-flex mb-2'>Select Card Payment Method</label>
                                                        
                                                            <div className='row ps-3'>
                                                                <div className="form-check w-25">
                                                                    <input
                                                                        className={'cp form-check-input dinner_menu_cp' + (index + 1)}
                                                                        type="radio"
                                                                        // name={`select_menu_${index + 1}`} // same name to group radio buttons
                                                                        // id={`dinnerMenu${index + 1}_${indexNumber + 1}`}
                                                                        value='manual'
                                                                        checked={hardwareDetail[index + 1]?.swipe_machine == 'manual'} // Ensure both are numbers or both are strings
                                                                        onChange={(e) => handleChangeData(e, (index + 1), 'swipe_machine')}
                                                                        autoComplete="off"
                                                                    />
                                                                    <label className="form-check-label cp">
                                                                        Manual
                                                                    </label>
                                                                    {/* <label className="form-check-label cp" htmlFor={`dinnerMenu${index + 1}_${indexNumber + 1}`}>
                                                                        Manual
                                                                    </label> */}
                                                                </div>

                                                                <div className="form-check w-25">
                                                                    <input
                                                                        className={'cp form-check-input dinner_menu_cp' + (index + 1)}
                                                                        type="radio"
                                                                        // name={`select_menu_${index + 1}`} // same name to group radio buttons
                                                                        // id={`dinnerMenu${index + 1}_${indexNumber + 1}`}
                                                                        value='nearpay'
                                                                        checked={hardwareDetail[index + 1]?.swipe_machine == 'nearpay'} // Ensure both are numbers or both are strings
                                                                        onChange={(e) => handleChangeData(e, (index + 1), 'swipe_machine')}
                                                                        autoComplete="off"
                                                                    />
                                                                    <label className="form-check-label cp">
                                                                        NearPay
                                                                    </label>
                                                                </div>

                                                                <div className="form-check w-25">
                                                                    <input
                                                                        className={'cp form-check-input dinner_menu_cp' + (index + 1)}
                                                                        type="radio"
                                                                        value='geidea'
                                                                        checked={hardwareDetail[index + 1]?.swipe_machine == 'geidea'} // Ensure both are numbers or both are strings
                                                                        onChange={(e) => handleChangeData(e, (index + 1), 'swipe_machine')}
                                                                        autoComplete="off"
                                                                    />
                                                                    <label className="form-check-label cp">
                                                                        Geidea
                                                                    </label>
                                                                </div>

                                                            </div>
                                                            <span className='text-danger d-flex text-left'>{errors.name && touched.name && errors.name}</span>
                                                        </div>
                                                    </div>        
                                                </div>
                                                <div className={' hardware_pos hardware_pos_' + (index + 1) + ' hardware_tab_' + (index + 1)} data-id="1" style={{ display: hardwareDetail[(index + 1)].hardware_used == 'pos' ? 'block' : 'none' }}>
                                                    <div className='row'>

                                                        <div className='col-lg-6 text-center form-group mt-3'>
                                                            <div className='d-flex justify-content-between'>
                                                            <label htmlFor='name' className='mb-1'>Device Name</label>
                                                            <span className='text-primary'>
                                                            {hardwareDetail[(index + 1)].is_main_cashier ? "Main cashier" : "Sub cashier"}
                                                            </span>
                                                        </div>
                                                            <input name='name[]' id="name" placeholder='Enter name' type='text' onChange={(e) => handleChangeData(e, (index + 1), 'name')} value={hardwareDetail[(index + 1)].name} className='form-control' autoComplete='off' />
                                                        </div>
                                                        <div className='col-lg-6 text-left form-group'></div>
                                                        
                                                        <div className='col-lg-6 text-center form-group mt-3'>
                                                            <label htmlFor='registration_id' className='text-left d-flex'>Device Registration ID </label>
                                                            <input name='registration_id' id="registration_id" type='text' onChange={(e) => handleChangeData(e, (index + 1), 'registration_id')} value={hardwareDetail[(index + 1)].registration_id} className='form-control' placeholder='Enter Registration ID' autoComplete='off' />
                                                        </div>
                                                        <div className='col-lg-6 text-left form-group'></div>

                                                        <div className='col-lg-6 text-center form-group mt-3'>
                                                            <label className='text-left d-flex'>
                                                                ZATCA Configuration <span className="requirestar">*</span>
                                                            </label>
                                                            <select
                                                                className='form-control'
                                                                value={hardwareDetail[(index + 1)].zatca_configuration_id || ''}
                                                                onChange={(e) => handleChangeData(e, (index + 1), 'zatca_configuration_id')}
                                                            >
                                                                <option value=''>None</option>
                                                                {(() => {
                                                                    const usedIds = Object.entries(hardwareDetail)
                                                                        .filter(([key]) => Number(key) !== index + 1)
                                                                        .map(([, d]) => String(d.zatca_configuration_id))
                                                                        .filter(Boolean);
                                                                    return deviceZatcaList
                                                                        // .filter(cfg => cfg.configuration_type === 'pos' && !usedIds.includes(String(cfg.id)))
                                                                        .filter(cfg => cfg.configuration_type === 'pos')
                                                                        .map(cfg => (
                                                                            <option key={cfg.id} value={cfg.id}>
                                                                                {cfg.configuration_name}
                                                                            </option>
                                                                        ));
                                                                })()}
                                                            </select>
                                                        </div>
                                                        <div className='col-lg-6 text-left form-group'></div>

                                                        {/* <div className='col-lg-6 text-left form-group'></div>
                                                        <div className='col-lg-6 text-center form-group mt-3'>
                                                            <label htmlFor='sdk_id' className='text-left d-flex'>SDK ID </label>
                                                            <input name='sdk_id[]' id="sdk_id" type='text' onChange={(e) => handleChangeData(e, (index + 1), 'sdk_id')} value={hardwareDetail[(index + 1)].sdk_id} className='form-control' placeholder='Enter SDK ID' autoComplete='off' />
                                                        </div> */}
                                                        
                                                        <div className='col-lg-6 text-left form-group mt-4'>
                                                            <label htmlFor='select_menu' className='text-left d-flex mb-2'>Select Menu</label>
                                                            <div className='row ps-3'>
                                                                {
                                                                    menus.length > 0 ? menus.map((menu, indexNumber) => {
                                                                        return (
                                                                            <div className="form-check w-25" key={menu.id}>
                                                                                <input
                                                                                    className={'cp form-check-input dinner_menu_cp' + (index + 1)}
                                                                                    type="radio"
                                                                                    name={`select_menu_${index + 1}`} // same name to group radio buttons
                                                                                    id={`dinnerMenu${index + 1}_${indexNumber + 1}`}
                                                                                    value={menu.id}
                                                                                    checked={hardwareDetail[index + 1]?.select_menu === menu.id} // Ensure both are numbers or both are strings
                                                                                    onChange={(e) => handleDinnerMenu(e, index + 1, 'select_menu', indexNumber)}
                                                                                    autoComplete="off"
                                                                                />
                                                                                <label className="form-check-label cp" htmlFor={`dinnerMenu${index + 1}_${indexNumber + 1}`}>
                                                                                    {capitalizeAllFirstLetters(menu.name)}
                                                                                </label>
                                                                            </div>
                                                                        );
                                                                    }) : null
                                                                }
                                                            </div>
                                                            <span className='text-danger d-flex text-left'>{errors.name && touched.name && errors.name}</span>
                                                        </div>
                                                        <div className='col-lg-6 text-left form-group'></div>
                                                        
                                                        {/* Customer Printer */}
                                                        <div className='col-lg-6 text-center form-group mt-4'>
                                                            <label htmlFor='printer_ip' className='text-left d-flex'>Customer Printer</label>                                                           
                                                        </div>
                                                        <div className='col-lg-6 text-left form-group'></div>

                                                        <div className="row">
                                                            {/* Printer IP */}
                                                            <div className="col-lg-6 form-group d-flex align-items-center">
                                                                <label htmlFor="printer_ip" className="fw-medium me-2 mb-0" style={{ width: "120px" }}>Printer IP</label>
                                                                <input name="printer_ip[]" id="printer_ip" placeholder="Enter printer IP" type="text" onChange={(e) => handleChangeData(e, index + 1, "customer_printer_ip")} value={hardwareDetail[index + 1]?.customer_printer_ip || ""} className="form-control" autoComplete="off"/>
                                                            </div>

                                                            {/* Printer Name */}
                                                            <div className="col-lg-6 form-group d-flex align-items-center">
                                                                <label htmlFor="name" className="fw-medium me-2 mb-0" style={{ width: "120px" }}>Printer Name</label>
                                                                <input name="name" id="name" placeholder="Enter name" type="text" onChange={(e) => handleChangeData(e, index + 1, "customer_printer_name")} value={hardwareDetail[index + 1]?.customer_printer_name || ""} className="form-control" autoComplete="off"/>
                                                            </div>
                                                        </div>
                                                        
                                                        {/* Kitchen Printer */}
                                                        <div className='col-lg-6 text-center form-group mt-4'>
                                                            <label htmlFor='printer_ip' className='text-left d-flex'>Kitchen Printer</label>                                                           
                                                        </div>
                                                        <div className='col-lg-6 text-left form-group'></div>
                                                        
                                                        <div className="row">
                                                            {/* Printer IP */}
                                                            <div className="col-lg-6 form-group d-flex align-items-center">
                                                                <label htmlFor="printer_ip" className="fw-medium me-2 mb-0" style={{ width: "120px" }}>Printer IP</label>
                                                                <input name="printer_ip[]" id="printer_ip" placeholder="Enter printer IP" type="text" onChange={(e) => handleChangeData(e, index + 1, "kitchen_printer_ip")} value={hardwareDetail[index + 1]?.kitchen_printer_ip || ""} className="form-control" autoComplete="off"/>
                                                            </div>

                                                            {/* Printer Name */}
                                                            <div className="col-lg-6 form-group d-flex align-items-center">
                                                                <label htmlFor="name" className="fw-medium me-2 mb-0" style={{ width: "120px" }}>Printer Name</label>
                                                                <input name="name" id="name" placeholder="Enter name" type="text" onChange={(e) => handleChangeData(e, index + 1, "kitchen_printer_name")} value={hardwareDetail[index + 1]?.kitchen_printer_name || ""} className="form-control" autoComplete="off"/>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <span className='text-danger d-flex text-left'>{hardwareError[index + 1] && "All fields are required"}</span>
                                            </div>
                                        ))}
                                    </div>
                                    <button type='button' className='btn btn-light text-primary mt-4 me-3' onClick={addMore} style={{
                                        display: btnHide ? 'none' : ''
                                    }} >  + Add More</button>
                                    {addMoreCount.length > 1 && (
                                        <button
                                            type='button'
                                            className='btn btn-danger mt-4 me-3'
                                            onClick={removeLast}
                                            style={{ display: btnHide ? 'none' : '' }}
                                        >
                                            Remove
                                        </button>
                                    )}
                                    <button
                                        type='button'
                                        className='btn btn-danger mt-4'
                                        onClick={clearAll}
                                        style={{ display: btnHide ? 'none' : '' }}
                                    >
                                        Clear
                                    </button>
                                </section>
                                <section id="section3" className="section3" style={{ display: 'none' }}>
                                    <div className='row'>
                                        <div className='col-lg-6 text-center form-group'>
                                            <label htmlFor='invoice_header_text_info' className='text-left d-flex'>Invoice Header Text Info </label>
                                            <textarea name='invoice_header_text_info' id="invoice_header_text_info" rows="2" type='text' onChange={handleChange} onBlur={handleBlur} value={values.invoice_header_text_info} className='form-control' placeholder='Enter invoice header text info' />
                                            <span className='text-danger d-flex text-left'>{errors.invoice_header_text_info && touched.invoice_header_text_info && errors.invoice_header_text_info}</span>

                                        </div>
                                        <div className='col-lg-6 text-center form-group'>
                                            <label htmlFor='invoice_footer_text_info' className='text-left d-flex'>Invoice Footer Text Info </label>
                                            <textarea name='invoice_footer_text_info' id="invoice_footer_text_info" rows="2" type='text' onChange={handleChange} onBlur={handleBlur} value={values.invoice_footer_text_info} className='form-control' placeholder='Enter invoice footer text info' />
                                            <span className='text-danger d-flex text-left'>{errors.invoice_footer_text_info && touched.invoice_footer_text_info && errors.invoice_footer_text_info}</span>

                                        </div>
                                        <div className='col-lg-6 text-left form-group mt-4'>
                                            <label htmlFor='end_of_the_day_configuration' className='text-left d-flex mb-2'>End of the day configuration </label>
                                            <div className='row ps-3'>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 text-center form-group mt-3'></div>
                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <div className="form-check w-25">
                                                        <input
                                                            className="form-check-input "
                                                            type="radio"
                                                            name="end_of_the_day_configuration"
                                                            id="automatic"
                                                            value={selectedOption}
                                                            checked={selectedOption === "automatic"}
                                                            onChange={() => handleOptionChange("automatic")}
                                                            onBlur={handleBlur}
                                                            autoComplete='off'
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                        <label style={{ cursor: 'pointer' }} className="form-check-label" htmlFor="automatic">
                                                            Automatic
                                                        </label>
                                                    </div>
                                                    <div className="form-check w-25">
                                                        <input
                                                            className="form-check-input "
                                                            type="radio"
                                                            name="end_of_the_day_configuration"
                                                            id="manual"
                                                            value={selectedOption}
                                                            onChange={() => handleOptionChange("manual")}
                                                            style={{ cursor: 'pointer' }}
                                                            onBlur={handleBlur}
                                                            autoComplete='off'
                                                            checked={selectedOption === "manual"}
                                                        />
                                                        <label className="form-check-label" style={{ cursor: 'pointer' }} htmlFor="manual">
                                                            Manual
                                                        </label>
                                                    </div>
                                                </div>
                                                {selectedOption === 'manual' && (
                                                    <div className='col-lg-6 text-center form-group mt-3'>

                                                    </div>
                                                )}

                                                {selectedOption === 'automatic' && (
                                                    <div className='col-lg-6 text-center form-group mt-3'>
                                                        <input
                                                            name='end_of_the_day_time'
                                                            id="end_of_the_day_time"
                                                            type='time'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values?.end_of_the_day_time || ''}
                                                            className='form-control'
                                                            autoComplete='off'
                                                        />

                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='col-lg-6 text-center form-group mt-3'></div>
                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='name' className='text-left d-flex mb-2'>Store opening and closing time</label>
                                            <table width='100%'>
                                                {storeTime?.map((row, i) => (
                                                    <tr>
                                                        <td className='px-2 py-3'>
                                                            <div className="form-check w-25">
                                                                <input className="form-check-input" style={{ cursor: 'pointer' }}
                                                                    type="checkbox"
                                                                    name={"is_" + row.value}
                                                                    id={"days_checkbox" + i}
                                                                    checked={values[`is_${row.value}`]}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        setFieldValue(`is_${row.value}`, e.target.checked);
                                                                    }}

                                                                    onBlur={handleBlur}
                                                                    autoComplete='off' />
                                                                <label className="form-check-label cp" htmlFor={"days_checkbox" + i}>{row.label}</label>
                                                            </div>
                                                        </td>
                                                        <td className='p-0 pe-0 w-100' colSpan={3}>
                                                            <div className='d-flex'>
                                                                {values[`is_${row.value}`] && (
                                                                    <>
                                                                        <InputGroup className='w-50 me-2'>
                                                                            <Form.Control
                                                                                type="time"
                                                                                placeholder="Opening Time"
                                                                                name={`${row.value}_opening_time`}
                                                                                onBlur={handleBlur}
                                                                                value={values[`${row.value}_opening_time`]}
                                                                                onChange={(event) => {
                                                                                    const time = event.target.value;
                                                                                    setFieldValue(row.value + '_opening_time', time);
                                                                                }}
                                                                            />
                                                                        </InputGroup>
                                                                        {/* <span className='text-danger d-block text-start'>{touched[`${row.value}_opening_time`] && errors[`${row.value}_opening_time`]}</span> */}
                                                                    </>
                                                                )}
                                                                {values[`is_${row.value}`] && (
                                                                    <>
                                                                        <InputGroup className='w-50'>
                                                                            <Form.Control
                                                                                type="time"
                                                                                placeholder="Closing Time"
                                                                                name={`${row.value}_closing_time`}
                                                                                value={values[`${row.value}_closing_time`]}
                                                                                onBlur={handleBlur}
                                                                                onChange={(event) => {
                                                                                    const closingTime = event.target.value;
                                                                                    setFieldValue(row.value + '_closing_time', closingTime);
                                                                                }}
                                                                            />
                                                                        </InputGroup>
                                                                        {/* <span className='text-danger d-block text-start'>{touched[`${row.value}_closing_time`] && errors[`${row.value}_closing_time`]}</span> */}
                                                                    </>
                                                                )}
                                                            </div>
                                                            <span className='text-danger d-block text-start'>{touched[`is_${row.value}`] && errors[`is_${row.value}`]}</span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </table>
                                        </div>
                                        <div className='col-lg-6 text-left form-group mt-3'></div>
                                        <div className='col-lg-6 text-left form-group mt-3'>
                                            <label htmlFor='copy_print_count' className='text-left d-flex mb-2'>How many copy of the check will be print ?</label>
                                            <input name='copy_print_count' id="copy_print_count" type='number' onChange={handleChange} onBlur={handleBlur} value={values.copy_print_count} className='form-control' placeholder='Enter number' autoComplete='off' />
                                            <span className='text-danger d-flex text-left'>{errors.copy_print_count || touched.copy_print_count}</span>
                                        </div>
                                    </div>
                                </section>
                                <section id="section4" className="section4" style={{ display: 'none' }}>
                                    <div className='row'>
                                        <div className="col-lg-12 text-center form-group mt-3">
                                            <label className="text-left d-flex">Service Type<span className="requirestar">*</span></label>
                                            <div className="row ps-3 mt-3">
                                                <div className="form-check w-25 text-start">
                                                    <input className="form-check-input cp" type="radio" name="service_type" id="quick_service" autocomplete="off" value="quick_service" checked={values.service_type === 'quick_service'} onChange={handleChange} onBlur={handleBlur} />
                                                    <label className="form-check-label cp" for="quick_service">Quick Service</label>
                                                </div>
                                                <div className="form-check w-25 text-start">
                                                    <input className="form-check-input cp" type="radio" name="service_type" id="table_service" autocomplete="off" value="table_service" checked={values.service_type === 'table_service'} onChange={handleChange} onBlur={handleBlur} />
                                                    <label className="form-check-label cp" for="table_service">Table Service</label>
                                                </div>
                                                <span className="text-danger d-flex text-left">{errors.service_type && touched.service_type && errors.service_type}</span>
                                            </div>
                                            <span className="text-danger d-flex text-left"></span>
                                        </div>
                                        {values?.service_type === 'table_service' &&
                                            <div className="col-lg-12 text-center form-group mt-3">
                                                <label className="text-left d-flex">Table Details</label>
                                                {values?.dine_tables?.map((table, index) => (
                                                    <div className="row gx-3 mb-2" key={index}>
                                                        <div className="col-3">
                                                            <input className='form-control' type='text' name={`dine_tables[${index}].table_number`} id={`dine_tables[${index}].table_number`} value={table.table_number} onChange={handleChange} onBlur={handleBlur} placeholder='Enter table number' autoComplete='off' />
                                                            {
                                                                errors[`dine_tables[${index}].table_number`] &&
                                                                touched.dine_tables &&
                                                                touched.dine_tables[index] &&
                                                                touched.dine_tables[index].table_number && (
                                                                    <span className="text-danger d-flex text-left">
                                                                        {errors[`dine_tables[${index}].table_number`]}
                                                                    </span>
                                                                )
                                                            }
                                                        </div>
                                                        <div className="col-3">
                                                            <input className='form-control' type='text' name={`dine_tables[${index}].table_name`} id={`dine_tables[${index}].table_name`} value={table.table_name} onChange={handleChange} onBlur={handleBlur} placeholder='Enter table name' autoComplete='off' />
                                                            {
                                                                errors[`dine_tables[${index}].table_name`] &&
                                                                touched.dine_tables &&
                                                                touched.dine_tables[index] &&
                                                                touched.dine_tables[index].table_name && (
                                                                    <span className="text-danger d-flex text-left">
                                                                        {errors[`dine_tables[${index}].table_name`]}
                                                                    </span>
                                                                )
                                                            }
                                                        </div>
                                                        <div className='col-1 d-flex'>
                                                            {values?.dine_tables?.length > 1 &&
                                                                <button type='button' className="btn btn-danger mx-1 rounded-circle" onClick={() => handleRemove(values, index, setFieldValue)}>✖</button>
                                                            }
                                                            {index === values?.dine_tables?.length - 1 &&
                                                                <button type='button' className="btn btn-primary mx-1 rounded-circle" onClick={() => handleAdd(values, setFieldValue)}>+</button>
                                                            }
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        }
                                    </div>
                                </section>
                                <section id="section5" className="section5" style={{ display: 'none' }}>
                                    <div className='row'>
                                        <div className='col-lg-6 text-center form-group mb-3'>
                                            <label htmlFor='erp_configuration.dimension_value_1' className='text-left d-flex'>Dimenssion value 1
                                                <Whisper
                                                    placement="top"
                                                    controlId="control-id-hover"
                                                    trigger="hover"
                                                    speaker={
                                                        <Tooltip>
                                                            Please Enter dimension value 1 as per the erp requirement.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="field-more-info ms-1 cp">?</span>
                                                </Whisper>
                                            </label>
                                            <input
                                                name='erp_configuration.dimension_value_1'
                                                id="erp_configuration.dimension_value_1"
                                                placeholder='Enter dimenssion value 1'
                                                type='text'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.erp_configuration.dimension_value_1}
                                                className='form-control'
                                                autoComplete='off'
                                            />
                                            {/* <span className='text-danger d-flex text-left'>{errors.dimension_value_1 && touched?.erp_configuration?.dimension_value_1 && errors.dimension_value_1}</span> */}
                                        </div>

                                        <div className='col-lg-6 text-center form-group mb-3'>
                                            <label htmlFor='erp_configuration.dimension_value_2' className='text-left d-flex'>Dimenssion value 2
                                                <Whisper
                                                    placement="top"
                                                    controlId="control-id-hover"
                                                    trigger="hover"
                                                    speaker={
                                                        <Tooltip>
                                                            Please Enter dimension value 2 as per the erp requirement.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="field-more-info ms-1 cp">?</span>
                                                </Whisper>
                                            </label>
                                            <input
                                                name='erp_configuration.dimension_value_2'
                                                id="erp_configuration.dimension_value_2"
                                                placeholder='Enter dimenssion value 2'
                                                type='text'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.erp_configuration.dimension_value_2}
                                                className='form-control'
                                                autoComplete='off'
                                            />
                                            {/* <span className='text-danger d-flex text-left'>{errors.dimension_value_2 && touched?.erp_configuration?.dimension_value_2 && errors.dimension_value_2}</span> */}
                                        </div>

                                        <div className='col-lg-6 text-center form-group mb-3'>
                                            <label htmlFor='erp_configuration.dimension_value_3' className='text-left d-flex'>Dimenssion value 3
                                                <Whisper
                                                    placement="top"
                                                    controlId="control-id-hover"
                                                    trigger="hover"
                                                    speaker={
                                                        <Tooltip>
                                                            Please Enter dimension value 3 as per the erp requirement.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="field-more-info ms-1 cp">?</span>
                                                </Whisper>
                                            </label>
                                            <input
                                                name='erp_configuration.dimension_value_3'
                                                id="erp_configuration.dimension_value_3"
                                                placeholder='Enter dimenssion value 3'
                                                type='text'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.erp_configuration.dimension_value_3}
                                                className='form-control'
                                                autoComplete='off'
                                            />
                                            {/* <span className='text-danger d-flex text-left'>{errors.dimension_value_3 && touched?.erp_configuration?.dimension_value_3 && errors.dimension_value_3}</span> */}
                                        </div>

                                        <div className='col-lg-6 text-center form-group mb-3'>
                                            <label htmlFor='erp_configuration.dimension_value_4' className='text-left d-flex'>Dimenssion value 4
                                                <Whisper
                                                    placement="top"
                                                    controlId="control-id-hover"
                                                    trigger="hover"
                                                    speaker={
                                                        <Tooltip>
                                                            Please Enter dimension value 4 as per the erp requirement.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="field-more-info ms-1 cp">?</span>
                                                </Whisper>
                                            </label>
                                            <input
                                                name='erp_configuration.dimension_value_4'
                                                id="erp_configuration.dimension_value_4"
                                                placeholder='Enter dimenssion value 4'
                                                type='text'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.erp_configuration.dimension_value_4}
                                                className='form-control'
                                                autoComplete='off'
                                            />
                                            {/* <span className='text-danger d-flex text-left'>{errors.dimension_value_4 && touched?.erp_configuration?.dimension_value_4 && errors.dimension_value_4}</span> */}
                                        </div>

                                        <div className='col-lg-6 text-center form-group mb-3'>
                                            <label htmlFor='erp_configuration.dimension_value_5' className='text-left d-flex'>Dimenssion value 5
                                                <Whisper
                                                    placement="top"
                                                    controlId="control-id-hover"
                                                    trigger="hover"
                                                    speaker={
                                                        <Tooltip>
                                                            Please Enter dimension value 5 as per the erp requirement.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="field-more-info ms-1 cp">?</span>
                                                </Whisper>
                                            </label>
                                            <input
                                                name='erp_configuration.dimension_value_5'
                                                id="erp_configuration.dimension_value_5"
                                                placeholder='Enter dimenssion value 5'
                                                type='text'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.erp_configuration.dimension_value_5}
                                                className='form-control'
                                                autoComplete='off'
                                            />
                                            {/* <span className='text-danger d-flex text-left'>{errors.dimension_value_5 && touched?.erp_configuration?.erp_configuration?.dimension_value_5 && errors.dimension_value_5}</span> */}
                                        </div>

                                        <div className='col-lg-6 text-center form-group mb-3'>
                                            <label htmlFor='erp_configuration.dimension_value_6' className='text-left d-flex'>Dimenssion value 6
                                                <Whisper
                                                    placement="top"
                                                    controlId="control-id-hover"
                                                    trigger="hover"
                                                    speaker={
                                                        <Tooltip>
                                                            Please Enter dimension value 6 as per the erp requirement.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="field-more-info ms-1 cp">?</span>
                                                </Whisper>
                                            </label>
                                            <input
                                                name='erp_configuration.dimension_value_6'
                                                id="erp_configuration.dimension_value_6"
                                                placeholder='Enter dimenssion value 6'
                                                type='text'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.erp_configuration.dimension_value_6}
                                                className='form-control'
                                                autoComplete='off'
                                            />
                                            {/* <span className='text-danger d-flex text-left'>{errors.dimension_value_6 && touched?.erp_configuration?.dimension_value_6 && errors.dimension_value_6}</span> */}
                                        </div>

                                        <div className='col-lg-6 text-center form-group'>
                                            <label htmlFor='erp_configuration.card_offset_value' className='text-left d-flex'>Card Offset Value
                                                <Whisper
                                                    placement="top"
                                                    controlId="control-id-hover"
                                                    trigger="hover"
                                                    speaker={
                                                        <Tooltip>
                                                            Please Enter card offset value as per the erp requirement.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="field-more-info ms-1 cp">?</span>
                                                </Whisper>
                                            </label>
                                            <input
                                                name='erp_configuration.card_offset_value'
                                                id="erp_configuration.card_offset_value"
                                                placeholder='Enter card offset value'
                                                type='text'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.erp_configuration.card_offset_value}
                                                className='form-control'
                                                autoComplete='off'
                                            />
                                            {/* <span className='text-danger d-flex text-left'>{errors.dimension_value_6 && touched?.erp_configuration?.dimension_value_6 && errors.dimension_value_6}</span> */}
                                        </div>

                                        <div className='col-lg-6 text-center form-group'>
                                            <label htmlFor='erp_configuration.cash_offset_value' className='text-left d-flex'>Cash Offset Value
                                                <Whisper
                                                    placement="top"
                                                    controlId="control-id-hover"
                                                    trigger="hover"
                                                    speaker={
                                                        <Tooltip>
                                                            Please Enter cash offset value as per the erp requirement.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="field-more-info ms-1 cp">?</span>
                                                </Whisper>
                                            </label>
                                            <input
                                                name='erp_configuration.cash_offset_value'
                                                id="erp_configuration.cash_offset_value"
                                                placeholder='Enter cash offset value'
                                                type='text'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.erp_configuration.cash_offset_value}
                                                className='form-control'
                                                autoComplete='off'
                                            />
                                            {/* <span className='text-danger d-flex text-left'>{errors.dimension_value_6 && touched?.erp_configuration?.dimension_value_6 && errors.dimension_value_6}</span> */}
                                        </div>

                                    </div>
                                </section>
                                <section id="section6" className="section6" style={{ display: "none" }}>
                                    <div className="col-lg-12">

                                        {/* Header */}
                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                            <h4 className="main-content-label mb-0">ZATCA Configurations</h4>
                                            {!showAddZatcaForm && (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                        setShowAddZatcaForm(true);
                                                        setZatcaRegMethod('otp');
                                                        setDeviceZatcaFile(null);
                                                        setDeviceZatcaErrors({});
                                                        setDeviceZatcaForm({ configuration_name: '', configuration_type: '', zatca_environment_type: '', vat_name: '', vat_number: '', organisation_unit_name: '', postal_zone: '', street: '', building: '', plot_identification: '', city_subdivision: '', otp: '' });
                                                    }}
                                                >
                                                    <i className="fa fa-plus me-2"></i> New Configuration
                                                </button>
                                            )}
                                        </div>

                                        {/* Configurations List */}
                                        <div className="tabler-wrap">
                                            <div className="table-responsive">
                                                <table className="table table-custom">
                                                    <thead>
                                                        <tr>
                                                            <th width="5%">#</th>
                                                            <th width="18%">Configuration Name</th>
                                                            <th width="10%">Type</th>
                                                            <th width="13%">Environment</th>
                                                            <th width="16%">VAT Name</th>
                                                            <th width="16%">VAT Number</th>
                                                            <th width="12%">Created At</th>
                                                            <th width="10%" className="action_head text-end">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {deviceZatcaLoading ? (
                                                            <tr>
                                                                <td colSpan={8}><TableLoader /></td>
                                                            </tr>
                                                        ) : (
                                                            <>
                                                                {deviceZatcaList.length > 0 ? (
                                                                    deviceZatcaList.map((cfg, index) => (
                                                                        <tr key={cfg.id}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{capitalizeFirstLetter(cfg.configuration_name) || 'N/A'}</td>
                                                                            <td>
                                                                                <span className={`badge ${cfg.configuration_type === 'pos' ? 'bg-primary' : 'bg-info'}`}>
                                                                                    {cfg.configuration_type?.toUpperCase() || 'N/A'}
                                                                                </span>
                                                                            </td>
                                                                            <td>
                                                                                <span className={`badge ${cfg.zatca_details?.zatca_environment_type === 'production' ? 'bg-success' : cfg.zatca_details?.zatca_environment_type === 'simulation' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                                                                                    {cfg.zatca_details?.zatca_environment_type?.toUpperCase() || 'N/A'}
                                                                                </span>
                                                                            </td>
                                                                            <td>{capitalizeFirstLetter(cfg.zatca_details?.vat_name) || 'N/A'}</td>
                                                                            <td>{cfg.zatca_details?.vat_number || 'N/A'}</td>
                                                                            <td>{cfg.created_at ? formateDate(cfg.created_at) : 'N/A'}</td>
                                                                            <td className="text-end">
                                                                                {cfg.zatca_onboarding_requested && !cfg.zatca_onboarding_requested_approved && (
                                                                                    <span className="badge bg-warning text-dark me-2">Onboarding Requested</span>
                                                                                )}
                                                                                <div className="dropdown d-inline-block">
                                                                                    <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                        <i className="ti ti-dots-vertical"></i>
                                                                                    </button>
                                                                                    <ul className="dropdown-menu">
                                                                                        <li>
                                                                                            <div className="dropdown-item" onClick={() => { setViewZatcaRecord(cfg); setViewZatcaModal(true); }}>
                                                                                                <i className="ti ti-eye" aria-hidden="true"></i> View details
                                                                                            </div>
                                                                                        </li>
                                                                                        {!cfg.zatca_onboarding_requested && !cfg.zatca_onboarding_requested_approved && (
                                                                                            <li>
                                                                                                <div className="dropdown-item" onClick={() => handleRegisterAgain(cfg)}>
                                                                                                    <i className="ti ti-refresh" aria-hidden="true"></i> Register Again
                                                                                                </div>
                                                                                            </li>
                                                                                        )}
                                                                                        {cfg.zatca_onboarding_requested_approved && (
                                                                                            <li>
                                                                                                <div className="dropdown-item" onClick={() => {
                                                                                                    setReUploadZatcaConfig(cfg);
                                                                                                    setShowAddZatcaForm(true);
                                                                                                    setZatcaRegMethod('otp');
                                                                                                    setDeviceZatcaFile(null);
                                                                                                    setDeviceZatcaErrors({});
                                                                                                    setDeviceZatcaForm({
                                                                                                        configuration_name: cfg.configuration_name || '',
                                                                                                        configuration_type: cfg.configuration_type || '',
                                                                                                        zatca_environment_type: cfg.zatca_details?.zatca_environment_type || '',
                                                                                                        vat_name: cfg.zatca_details?.vat_name || '',
                                                                                                        vat_number: cfg.zatca_details?.vat_number || '',
                                                                                                        organisation_unit_name: cfg.zatca_details?.organisation_unit_name || '',
                                                                                                        postal_zone: cfg.zatca_details?.postal_zone || '',
                                                                                                        street: cfg.zatca_details?.street || '',
                                                                                                        building: cfg.zatca_details?.building || '',
                                                                                                        plot_identification: cfg.zatca_details?.plot_identification || '',
                                                                                                        city_subdivision: cfg.zatca_details?.city_subdivision || '',
                                                                                                        otp: ''
                                                                                                    });
                                                                                                }}>
                                                                                                    <i className="ti ti-upload" aria-hidden="true"></i> Upload ZATCA Again
                                                                                                </div>
                                                                                            </li>
                                                                                        )}
                                                                                    </ul>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={8} className="text-center">
                                                                            <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                                            <p>No records</p>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* Add New Configuration Form */}
                                        {showAddZatcaForm && (
                                            <div className="card custom-card">
                                                <div className="card-header d-flex justify-content-between align-items-center">
                                                    <h5 className="mb-0">{reUploadZatcaConfig ? `Re-upload: ${capitalizeFirstLetter(reUploadZatcaConfig.configuration_name)}` : 'New ZATCA Configuration'}</h5>
                                                    <button type="button" className="btn-close" onClick={() => { setShowAddZatcaForm(false); setReUploadZatcaConfig(null); }}></button>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">

                                                        {/* Configuration Name */}
                                                        <div className="col-lg-6 form-group mb-3">
                                                            <label className="text-left d-flex">Configuration Name <span className="requirestar">*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="e.g. Main POS, Counter 1"
                                                                value={deviceZatcaForm.configuration_name}
                                                                onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, configuration_name: e.target.value })}
                                                            />
                                                            {deviceZatcaErrors.configuration_name && <span className="text-danger d-flex">{deviceZatcaErrors.configuration_name}</span>}
                                                        </div>

                                                        {/* Configuration Type */}
                                                        <div className="col-lg-6 form-group mb-3">
                                                            <label className="text-left d-flex">Configuration Type <span className="requirestar">*</span></label>
                                                            <select
                                                                className="form-control"
                                                                value={deviceZatcaForm.configuration_type}
                                                                onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, configuration_type: e.target.value })}
                                                            >
                                                                <option value="">Select Type</option>
                                                                <option value="pos">POS</option>
                                                                <option value="online">Online</option>
                                                            </select>
                                                            {deviceZatcaErrors.configuration_type && <span className="text-danger d-flex">{deviceZatcaErrors.configuration_type}</span>}
                                                        </div>

                                                        {/* Registration Method */}
                                                        <div className="col-lg-12 form-group mb-4">
                                                            <label className="text-left d-flex mb-2">Registration Method <span className="requirestar">*</span></label>
                                                            <div className="d-flex gap-4">
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        id="zatca_method_otp"
                                                                        checked={zatcaRegMethod === 'otp'}
                                                                        onChange={() => { setZatcaRegMethod('otp'); setDeviceZatcaFile(null); setDeviceZatcaErrors({}); }}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="zatca_method_otp">Register via OTP</label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        id="zatca_method_upload"
                                                                        checked={zatcaRegMethod === 'upload'}
                                                                        onChange={() => { setZatcaRegMethod('upload'); setDeviceZatcaErrors({}); }}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="zatca_method_upload">Upload Certificate</label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* OTP Fields */}
                                                        {zatcaRegMethod === 'otp' && (
                                                            <>
                                                                {/* Environment Type */}
                                                                <div className="col-lg-6 form-group mb-3">
                                                                    <label className="text-left d-flex">ZATCA Environment <span className="requirestar">*</span></label>
                                                                    <select
                                                                        className="form-control"
                                                                        value={deviceZatcaForm.zatca_environment_type}
                                                                        onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, zatca_environment_type: e.target.value })}
                                                                    >
                                                                        <option value="">Select Environment</option>
                                                                        {zatcaEnvironmentType.map(env => (
                                                                            <option key={env.value} value={env.value}>{env.key}</option>
                                                                        ))}
                                                                    </select>
                                                                    {deviceZatcaErrors.zatca_environment_type && <span className="text-danger d-flex">{deviceZatcaErrors.zatca_environment_type}</span>}
                                                                </div>
                                                                <div className="col-lg-6 form-group mb-3">
                                                                    <label className="text-left d-flex">Organization Name <span className="requirestar">*</span></label>
                                                                    <input type="text" className="form-control" placeholder="Enter organization name" value={deviceZatcaForm.vat_name} onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, vat_name: e.target.value })} />
                                                                    {deviceZatcaErrors.vat_name && <span className="text-danger d-flex">{deviceZatcaErrors.vat_name}</span>}
                                                                </div>
                                                                <div className="col-lg-6 form-group mb-3">
                                                                    <label className="text-left d-flex">VAT Number <span className="requirestar">*</span></label>
                                                                    <input type="text" className="form-control" placeholder="Enter VAT number" value={deviceZatcaForm.vat_number} onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, vat_number: e.target.value })} />
                                                                    {deviceZatcaErrors.vat_number && <span className="text-danger d-flex">{deviceZatcaErrors.vat_number}</span>}
                                                                </div>
                                                                <div className="col-lg-6 form-group mb-3">
                                                                    <label className="text-left d-flex">Organization Unit Name <span className="requirestar">*</span></label>
                                                                    <input type="text" className="form-control" placeholder="Enter organization unit name" value={deviceZatcaForm.organisation_unit_name} onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, organisation_unit_name: e.target.value })} />
                                                                    {deviceZatcaErrors.organisation_unit_name && <span className="text-danger d-flex">{deviceZatcaErrors.organisation_unit_name}</span>}
                                                                </div>
                                                                <div className="col-lg-6 form-group mb-3">
                                                                    <label className="text-left d-flex">Postal Zone <span className="requirestar">*</span></label>
                                                                    <input type="text" className="form-control" placeholder="Enter postal zone" value={deviceZatcaForm.postal_zone} onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, postal_zone: e.target.value })} />
                                                                    {deviceZatcaErrors.postal_zone && <span className="text-danger d-flex">{deviceZatcaErrors.postal_zone}</span>}
                                                                </div>
                                                                <div className="col-lg-3 form-group mb-3">
                                                                    <label className="text-left d-flex">Street <span className="requirestar">*</span></label>
                                                                    <input type="text" className="form-control" placeholder="Enter street" value={deviceZatcaForm.street} onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, street: e.target.value })} />
                                                                    {deviceZatcaErrors.street && <span className="text-danger d-flex">{deviceZatcaErrors.street}</span>}
                                                                </div>
                                                                <div className="col-lg-3 form-group mb-3">
                                                                    <label className="text-left d-flex">Building <span className="requirestar">*</span></label>
                                                                    <input type="text" className="form-control" placeholder="Enter building" value={deviceZatcaForm.building} onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, building: e.target.value })} />
                                                                    {deviceZatcaErrors.building && <span className="text-danger d-flex">{deviceZatcaErrors.building}</span>}
                                                                </div>
                                                                <div className="col-lg-3 form-group mb-3">
                                                                    <label className="text-left d-flex">Plot Identification <span className="requirestar">*</span></label>
                                                                    <input type="text" className="form-control" placeholder="Enter plot identification" value={deviceZatcaForm.plot_identification} onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, plot_identification: e.target.value })} />
                                                                    {deviceZatcaErrors.plot_identification && <span className="text-danger d-flex">{deviceZatcaErrors.plot_identification}</span>}
                                                                </div>
                                                                <div className="col-lg-3 form-group mb-3">
                                                                    <label className="text-left d-flex">City Subdivision <span className="requirestar">*</span></label>
                                                                    <input type="text" className="form-control" placeholder="Enter city subdivision" value={deviceZatcaForm.city_subdivision} onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, city_subdivision: e.target.value })} />
                                                                    {deviceZatcaErrors.city_subdivision && <span className="text-danger d-flex">{deviceZatcaErrors.city_subdivision}</span>}
                                                                </div>
                                                                <div className="col-lg-6 form-group mb-3">
                                                                    <label className="text-left d-flex">OTP <span className="requirestar">*</span></label>
                                                                    <input type="text" className="form-control" placeholder="Enter OTP" value={deviceZatcaForm.otp} onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, otp: e.target.value })} />
                                                                    {deviceZatcaErrors.otp && <span className="text-danger d-flex">{deviceZatcaErrors.otp}</span>}
                                                                </div>
                                                            </>
                                                        )}

                                                        {/* File Upload */}
                                                        {zatcaRegMethod === 'upload' && (
                                                            <>
                                                            <div className="col-lg-6 form-group mb-3">
                                                                <label className="text-left d-flex">ZATCA Environment <span className="requirestar">*</span></label>
                                                                <select
                                                                    className="form-control"
                                                                    value={deviceZatcaForm.zatca_environment_type}
                                                                    onChange={e => setDeviceZatcaForm({ ...deviceZatcaForm, zatca_environment_type: e.target.value })}
                                                                >
                                                                    <option value="">Select Environment</option>
                                                                    {zatcaEnvironmentType.map(env => (
                                                                        <option key={env.value} value={env.value}>{env.key}</option>
                                                                    ))}
                                                                </select>
                                                                {deviceZatcaErrors.zatca_environment_type && <span className="text-danger d-flex">{deviceZatcaErrors.zatca_environment_type}</span>}
                                                            </div>
                                                            <div className="col-lg-12 form-group mb-3">
                                                                <div
                                                                    style={{ border: '2px dashed #3598ff', borderRadius: '8px', padding: '48px', textAlign: 'center', cursor: 'pointer', background: '#f8fbff' }}
                                                                    onClick={() => deviceZatcaFileRef.current?.click()}
                                                                >
                                                                    <input
                                                                        ref={deviceZatcaFileRef}
                                                                        type="file"
                                                                        accept=".json"
                                                                        className="d-none"
                                                                        onChange={e => { if (e.target.files[0]) setDeviceZatcaFile(e.target.files[0]); }}
                                                                    />
                                                                    {deviceZatcaFile ? (
                                                                        <>
                                                                            <i className="fa fa-file-code-o" style={{ fontSize: '3em', color: '#3598ff' }}></i>
                                                                            <p className="mt-2 mb-1 fw-bold">{deviceZatcaFile.name}</p>
                                                                            <small className="text-muted">Click to change file</small>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <i className="fa fa-upload" style={{ fontSize: '3em', color: '#3598ff' }}></i>
                                                                            <p className="mt-2 mb-1">Click to upload ZATCA certificate</p>
                                                                            <small className="text-muted">Supported format: .json</small>
                                                                        </>
                                                                    )}
                                                                </div>
                                                                {deviceZatcaErrors.file && <span className="text-danger d-flex mt-1">{deviceZatcaErrors.file}</span>}
                                                                <div className="mt-2">
                                                                    <a href={ZatcaSampleFileJsonPath} download className="btn btn-sm btn-outline-secondary">
                                                                        <i className="fa fa-download me-1"></i> Download Sample Certificate
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            </>
                                                        )}

                                                        {/* Actions */}
                                                        <div className="col-lg-12 mt-3 d-flex gap-2">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                disabled={deviceZatcaLoading}
                                                                onClick={handleSubmitDeviceZatca}
                                                            >
                                                                {deviceZatcaLoading
                                                                    ? <><span className="spinner-border spinner-border-sm me-2" role="status"></span>Registering...</>
                                                                    : 'Register'
                                                                }
                                                            </button>
                                                            <button type="button" className="btn btn-secondary" onClick={() => { setShowAddZatcaForm(false); setReUploadZatcaConfig(null); }}>Cancel</button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </section>

                                {/* ZATCA Configuration View Modal */}
                                <Modal show={viewZatcaModal} onHide={() => setViewZatcaModal(false)} size="lg" centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title>ZATCA Configuration Details</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                        {viewZatcaRecord && (
                                            <div className="row">
                                                <div className="col-12 mb-3">
                                                    <h6 className="text-muted mb-3 border-bottom pb-2">General</h6>
                                                    <div className="row">
                                                        <div className="col-lg-6 mb-3">
                                                            <label className="fw-semibold d-block">Configuration Name</label>
                                                            <span>{capitalizeFirstLetter(viewZatcaRecord.configuration_name) || 'N/A'}</span>
                                                        </div>
                                                        <div className="col-lg-6 mb-3">
                                                            <label className="fw-semibold d-block">Configuration Type</label>
                                                            <span className={`badge ${viewZatcaRecord.configuration_type === 'pos' ? 'bg-primary' : 'bg-info'}`}>
                                                                {viewZatcaRecord.configuration_type?.toUpperCase() || 'N/A'}
                                                            </span>
                                                        </div>
                                                        <div className="col-lg-6 mb-3">
                                                            <label className="fw-semibold d-block">Created At</label>
                                                            <span>{viewZatcaRecord.created_at ? formateDate(viewZatcaRecord.created_at) : 'N/A'}</span>
                                                        </div>
                                                        <div className="col-lg-6 mb-3">
                                                            <label className="fw-semibold d-block">Last Invoice Counter</label>
                                                            <span>{viewZatcaRecord.last_invoice_counter_number ?? 'N/A'}</span>
                                                        </div>
                                                        <div className="col-lg-6 mb-3">
                                                            <label className="fw-semibold d-block">Onboarding Requested</label>
                                                            <span className={`badge ${viewZatcaRecord.zatca_onboarding_requested ? 'bg-success' : 'bg-secondary'}`}>
                                                                {viewZatcaRecord.zatca_onboarding_requested ? 'Yes' : 'No'}
                                                            </span>
                                                        </div>
                                                        <div className="col-lg-6 mb-3">
                                                            <label className="fw-semibold d-block">Onboarding Approved</label>
                                                            <span className={`badge ${viewZatcaRecord.zatca_onboarding_requested_approved ? 'bg-success' : 'bg-secondary'}`}>
                                                                {viewZatcaRecord.zatca_onboarding_requested_approved ? 'Yes' : 'No'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                {viewZatcaRecord.zatca_details && (
                                                    <div className="col-12">
                                                        <h6 className="text-muted mb-3 border-bottom pb-2">ZATCA Details</h6>
                                                        <div className="row">
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">Environment</label>
                                                                <span className={`badge ${viewZatcaRecord.zatca_details.zatca_environment_type === 'production' ? 'bg-success' : viewZatcaRecord.zatca_details.zatca_environment_type === 'simulation' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                                                                    {viewZatcaRecord.zatca_details.zatca_environment_type?.toUpperCase() || 'N/A'}
                                                                </span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">VAT Name</label>
                                                                <span>{capitalizeFirstLetter(viewZatcaRecord.zatca_details.vat_name) || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">VAT Number</label>
                                                                <span>{viewZatcaRecord.zatca_details.vat_number || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">Organization Unit Name</label>
                                                                <span>{capitalizeFirstLetter(viewZatcaRecord.zatca_details.organisation_unit_name) || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">Street</label>
                                                                <span>{capitalizeFirstLetter(viewZatcaRecord.zatca_details.street) || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">Building</label>
                                                                <span>{viewZatcaRecord.zatca_details.building || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">Plot Identification</label>
                                                                <span>{viewZatcaRecord.zatca_details.plot_identification || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">City Subdivision</label>
                                                                <span>{capitalizeFirstLetter(viewZatcaRecord.zatca_details.city_subdivision) || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">Postal Zone</label>
                                                                <span>{viewZatcaRecord.zatca_details.postal_zone || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">Compliance Request ID</label>
                                                                <span className="text-break small">{viewZatcaRecord.zatca_details.compliance_request_id || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">Compliance Secret</label>
                                                                <span className="text-break small">{viewZatcaRecord.zatca_details.compliance_secret || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">Production Request ID</label>
                                                                <span className="text-break small">{viewZatcaRecord.zatca_details.production_request_id || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-lg-6 mb-3">
                                                                <label className="fw-semibold d-block">Production Secret</label>
                                                                <span className="text-break small">{viewZatcaRecord.zatca_details.production_secret || 'N/A'}</span>
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <label className="fw-semibold d-block">Private Key</label>
                                                                <textarea className="form-control form-control-sm" rows={4} readOnly value={viewZatcaRecord.zatca_details.private_key || 'N/A'} />
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <label className="fw-semibold d-block">Public Key</label>
                                                                <textarea className="form-control form-control-sm" rows={4} readOnly value={viewZatcaRecord.zatca_details.public_key || 'N/A'} />
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <label className="fw-semibold d-block">CSR</label>
                                                                <textarea className="form-control form-control-sm" rows={4} readOnly value={viewZatcaRecord.zatca_details.csr || 'N/A'} />
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <label className="fw-semibold d-block">Compliance Certificate</label>
                                                                <textarea className="form-control form-control-sm" rows={4} readOnly value={viewZatcaRecord.zatca_details.compliance_certificate || 'N/A'} />
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <label className="fw-semibold d-block">Production Certificate</label>
                                                                <textarea className="form-control form-control-sm" rows={4} readOnly value={viewZatcaRecord.zatca_details.production_certificate || 'N/A'} />
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <label className="fw-semibold d-block">Previous Invoice Hash</label>
                                                                <textarea className="form-control form-control-sm" rows={2} readOnly value={viewZatcaRecord.zatca_details.previous_invoice_hash || viewZatcaRecord.previous_invoice_hash || 'N/A'} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setViewZatcaModal(false)}>Close</Button>
                                    </Modal.Footer>
                                </Modal>
                                <div className="button-container mt-4 d-flex justify-content-between align-items-center">
                                    <div>
                                        {page > 1 && (
                                            <button className="btn btn-outline-primary btn-prev" type="button" onClick={prevStep}>Back</button>
                                        )}
                                        {page < 6 && (
                                            <button className="btn btn-next btn-primary ms-2" type="button" onClick={nextStep} disabled={btnDisable}> Next</button>
                                        )}
                                    </div>
                                    <button className="btn btn btn-primary ms-2 btn-submit" type="submit">Submit</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </form>
            )}
            </Formik>
            <ToastContainer
                position="top-right"
                hideProgressBar={false}
                autoClose={true | 1000}
                newestOnTop={true}
                closeOnClick={false}
                draggable={false}
                rtl={false}
            />
        </>

    )
}

export default OutletEdit
